/*
 * Renneway Account Page — Shopify /pages/account SPA
 * Tüm buyer süreçleri (login/register/şifre sıfırlama/sipariş/adres/ayarlar)
 * tek sayfada, sayfa yenilemesi/redirect olmadan yürür.
 */
(function () {
  'use strict';

  var API_BASE = (window.RENNEWAY_API_BASE || '').replace(/\/+$/, '');

  // ---- State ----
  var state = {
    customer: null,
    addresses: [],
    orders: [],
    currentOrderId: null
  };

  // ---- TR translate cache (locale=tr durumunda product title gibi DATA alanlari)
  // localStorage'ta map tutar: { 'EN text': 'TR text' }. Backend proxy /api/public/translate
  // sadece bilinmeyen text'ler icin cagrilir.
  var TR_CACHE_KEY = 'rnw-tr-translate-cache-v1';
  var trCache = (function () {
    try { return JSON.parse(localStorage.getItem(TR_CACHE_KEY) || '{}') || {}; }
    catch (e) { return {}; }
  })();
  function trCacheSave() {
    try { localStorage.setItem(TR_CACHE_KEY, JSON.stringify(trCache)); } catch (e) {}
  }
  function isTRLocale() {
    return !!(window.RENNEWAY_I18N && /^tr/i.test(String(window.RENNEWAY_I18N.locale || '')));
  }
  // Verilen text array'i TR'ye cevirir, cache kullanir. Cevrilmis array doner.
  function translateBatchTR(texts) {
    if (!isTRLocale()) return Promise.resolve(texts.slice());
    var needs = [];
    texts.forEach(function (t) {
      var key = String(t || '').trim();
      if (key && !(key in trCache)) needs.push(key);
    });
    var uniqNeeds = [];
    var seen = {};
    needs.forEach(function (t) { if (!seen[t]) { seen[t] = 1; uniqNeeds.push(t); } });
    if (!uniqNeeds.length) {
      return Promise.resolve(texts.map(function (t) {
        var k = String(t || '').trim();
        return trCache[k] || t;
      }));
    }
    return fetch(API_BASE + '/api/public/translate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ texts: uniqNeeds, source: 'en', target: 'tr' })
    })
      .then(function (r) { return r.ok ? r.json() : { translations: [] }; })
      .then(function (data) {
        (data.translations || []).forEach(function (tr, i) {
          if (tr) trCache[uniqNeeds[i]] = tr;
        });
        trCacheSave();
        return texts.map(function (t) {
          var k = String(t || '').trim();
          return trCache[k] || t;
        });
      })
      .catch(function () { return texts.slice(); });
  }
  // State'teki orders[*].productSnapshot.title'lari TR'ye cevirip
  // productSnapshot.titleDisplay alanina yazar (orijinal title da korunur).
  function applyTRTitlesToOrders() {
    if (!isTRLocale() || !state.orders || !state.orders.length) return Promise.resolve();
    var titles = state.orders.map(function (o) { return (o.productSnapshot && o.productSnapshot.title) || ''; });
    return translateBatchTR(titles).then(function (translated) {
      state.orders.forEach(function (o, i) {
        if (o.productSnapshot) o.productSnapshot.titleDisplay = translated[i] || o.productSnapshot.title;
      });
    });
  }

  // ---- DOM helpers ----
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return (root || document).querySelectorAll(sel); }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function fmtDate(d, withTime) {
    var dt = new Date(d);
    if (isNaN(dt)) return '—';
    var opts = withTime
      ? { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }
      : { day: '2-digit', month: 'short', year: 'numeric' };
    return dt.toLocaleDateString(isTurkish() ? 'tr-TR' : 'en-GB', opts);
  }

  function money(n, currency) {
    var cur = currency || 'USD';
    var num = Number(n || 0);
    return '$' + num.toFixed(2) + (cur !== 'USD' ? ' ' + cur : '');
  }

  function statusInfo(s) {
    var T = window.rnwT || function(k,f){return f;};
    var map = {
      pending_payment: { label: T('status.pending_payment','Payment pending'), style: 'background:#fef3c7;color:#92400e' },
      paid:            { label: T('status.paid','Paid'),                       style: 'background:#d1fae5;color:#065f46' },
      preparing:       { label: T('status.preparing','Preparing'),             style: 'background:#dbeafe;color:#1e40af' },
      in_production:   { label: T('status.in_production','In production'),     style: 'background:#ede9fe;color:#5b21b6' },
      ready_to_ship:   { label: T('status.ready_to_ship','Ready to ship'),     style: 'background:#cffafe;color:#155e75' },
      shipped:         { label: T('status.shipped','Shipped'),                 style: 'background:#e0e7ff;color:#3730a3' },
      delivered:       { label: T('status.delivered','Delivered'),             style: 'background:#dcfce7;color:#14532d' },
      cancelled:       { label: T('status.cancelled','Cancelled'),             style: 'background:#fee2e2;color:#991b1b' },
      payment_failed:  { label: T('status.payment_failed','Failed'),           style: 'background:#fee2e2;color:#991b1b' }
    };
    return map[s] || { label: s || '—', style: 'background:#f5f3ed;color:#797971' };
  }

  function allowedActionsForOrderStatus(s) {
    if (s === 'pending_payment' || s === 'paid' || s === 'preparing' ||
        s === 'in_production' || s === 'ready_to_ship') return ['cancel'];
    if (s === 'shipped' || s === 'delivered') return ['return', 'exchange'];
    return [];
  }

  // i18n hook ile sarılan label map'leri — TR locale'inde rnwT() ile çevrilir,
  // fallback EN literal kalır. Yeni key ekledikçe sadece tr.json/en.default.json güncellenir.
  function _t(key, fb) { return (window.rnwT ? window.rnwT(key, fb) : fb); }
  var REASON_LABEL = {
    get defective()           { return _t('reason.defective',           'Defective product'); },
    get wrong_color_or_number(){ return _t('reason.wrong_color_or_number','Wrong color or count'); },
    get wrong_order()         { return _t('reason.wrong_order',         'Wrong order placed'); },
    get late()                { return _t('reason.late',                'Late delivery'); },
    // Geriye uyumlu (eski kayıtlar)
    get wrong_color()         { return _t('reason.wrong_color',         'Wrong color'); },
    get wrong_number()        { return _t('reason.wrong_number',        'Wrong size/count'); },
    get qty_short()           { return _t('reason.qty_short',           'Short quantity'); },
    get changed_mind()        { return _t('reason.changed_mind',        'Changed my mind'); },
    get other()               { return _t('reason.other',               'Other'); }
  };
  var TYPE_LABEL = {
    get cancel()   { return _t('request_type.cancel',   'Cancel'); },
    get return()   { return _t('request_type.return',   'Return'); },
    get exchange() { return _t('request_type.exchange', 'Exchange'); }
  };
  var TYPE_NOUN = { cancel: 'cancellation', return: 'return', exchange: 'exchange' };
  var RESOLUTION_LABEL = { refund: 'Refund', replacement: 'Replacement', store_credit: 'Store credit', discount: 'Discount' };
  var REQUEST_STATUS_LABEL = {
    requested: 'New request',
    supplier_review: 'Supplier reviewing',
    approved: 'Approved',
    rejected: 'Rejected',
    completed: 'Completed',
    closed: 'Closed',
    cancelled_by_buyer: 'Cancelled by you'
  };
  var REQUEST_STATUS_STYLE = {
    requested: 'background:#dbeafe;color:#1e40af',
    supplier_review: 'background:#fef3c7;color:#92400e',
    approved: 'background:#d1fae5;color:#065f46',
    rejected: 'background:#fee2e2;color:#991b1b',
    completed: 'background:#dcfce7;color:#14532d',
    closed: 'background:#f5f3ed;color:#797971',
    cancelled_by_buyer: 'background:#f5f3ed;color:#797971'
  };

  // Latest effective status to show for an order: prefer any live order-request
  // (cancel/return/exchange in a non-final state) — that's what the buyer actually cares about.
  // Otherwise fall back to the order's own status.
  function effectiveStatusInfo(order, requests) {
    var rqs = Array.isArray(requests) ? requests : [];
    if (rqs.length) {
      // Pick the most recently updated request whose status is not 'closed' or 'cancelled_by_buyer'.
      // If all are closed, pick the most recent one anyway — it still tells the buyer what happened.
      var sorted = rqs.slice().sort(function (a, b) {
        return new Date(b.updatedAt || b.createdAt || 0) - new Date(a.updatedAt || a.createdAt || 0);
      });
      var live = sorted.find(function (r) {
        return r.status !== 'closed' && r.status !== 'cancelled_by_buyer';
      }) || sorted[0];
      if (live) {
        var typeNoun = TYPE_NOUN[live.type] || live.type;
        var statusLabel = REQUEST_STATUS_LABEL[live.status] || live.status;
        // Compose: "Cancellation approved", "Return rejected", "Exchange completed", etc.
        var composed = typeNoun.charAt(0).toUpperCase() + typeNoun.slice(1) + ' ' + statusLabel.toLowerCase();
        return {
          label: composed,
          style: REQUEST_STATUS_STYLE[live.status] || 'background:#f5f3ed;color:#797971'
        };
      }
    }
    return statusInfo(order.status);
  }

  function isActiveOrder(s) {
    return s === 'paid' || s === 'preparing' || s === 'shipped';
  }
  function isCountedOrder(s) {
    return s !== 'cancelled' && s !== 'payment_failed' && s !== 'pending_payment';
  }
  function timeGreeting() {
    var h = new Date().getHours();
    var T = window.rnwT || function(k,f){return f;};
    if (h < 6) return T('account.good_evening','Good night');
    if (h < 12) return T('account.good_morning','Good morning');
    if (h < 18) return T('account.good_afternoon','Good afternoon');
    return T('account.good_evening','Good evening');
  }
  function firstName(full) {
    if (!full) return '';
    return String(full).trim().split(/\s+/)[0];
  }

  function api(path, opts) {
    opts = opts || {};
    var init = { credentials: 'include', method: opts.method || 'GET', headers: { 'Accept': 'application/json' } };
    if (opts.body !== undefined) {
      init.headers['Content-Type'] = 'application/json';
      init.body = JSON.stringify(opts.body);
    }
    // Bearer token — cookie 3. taraf engeline takilsa da oturum tasinir
    var tok = window.rnwToken ? window.rnwToken.get() : '';
    if (tok) init.headers['Authorization'] = 'Bearer ' + tok;
    return fetch(API_BASE + path, init).then(function (r) {
      return r.json().then(function (data) {
        // Login/register/reset cevaplari sessionToken doner — merkezi yakala
        if (r.ok && data && data.sessionToken && window.rnwToken) window.rnwToken.set(data.sessionToken);
        return { ok: r.ok, status: r.status, data: data };
      }).catch(function () {
        return { ok: r.ok, status: r.status, data: {} };
      });
    });
  }

  // ---- View / Tab switching ----

  function showView(name) {
    $$('[data-rnw-view]').forEach(function (el) {
      el.hidden = el.getAttribute('data-rnw-view') !== name;
    });
  }

  function showTab(name) {
    $$('[data-rnw-tab]').forEach(function (el) {
      el.hidden = el.getAttribute('data-rnw-tab') !== name;
    });
    $$('[data-rnw-tab-link]').forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-rnw-tab-link') === name);
    });
    // URL hash güncelle
    try { window.history.replaceState(null, '', '#' + name); } catch (e) {}
  }

  function switchAuthTab(name) {
    $$('[data-rnw-auth-tab]').forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-rnw-auth-tab') === name);
    });
    // forgot sekmesi karta yok, login sekmesi aktif görünür
    if (name === 'forgot') {
      var loginTab = $('[data-rnw-auth-tab="login"]');
      if (loginTab) loginTab.classList.add('is-active');
    }
    $$('[data-rnw-auth-pane]').forEach(function (p) {
      p.hidden = p.getAttribute('data-rnw-auth-pane') !== name;
    });
    hideAllAuthErrors();
  }

  function hideAllAuthErrors() {
    $$('[data-rnw-auth-err]').forEach(function (e) { e.hidden = true; });
    $$('[data-rnw-auth-success]').forEach(function (e) { e.hidden = true; });
  }

  function showAuthError(form, msg) {
    var el = $('[data-rnw-auth-err="' + form + '"]');
    if (el) { el.textContent = msg; el.hidden = false; }
  }

  function showAuthSuccess(form) {
    var el = $('[data-rnw-auth-success="' + form + '"]');
    if (el) el.hidden = false;
  }

  // ---- Init ----

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    if (!$('#rnw-account')) return;

    // 1. URL'yi kontrol et — reset linki mi?
    var params = new URLSearchParams(window.location.search);
    if (params.get('reset') === '1' && params.get('email') && params.get('token')) {
      initResetView(params.get('email'), params.get('token'));
      return;
    }

    bindAuthForms();
    bindDashboard();
    bindResetForm();

    // 2. Logged in mi?
    api('/panel/buyer/api/me').then(function (res) {
      if (res.data && res.data.loggedIn) {
        state.customer = res.data.customer;
        state.addresses = state.customer.addresses || [];
        showDashboard();
      } else {
        // Token gecersizlesmis (session silinmis/suresi dolmus) — temizle
        if (window.rnwToken) window.rnwToken.set('');
        showAuthView();
      }
    }).catch(function () {
      showAuthView();
    });
  }

  // ---- Auth view (logged out) ----

  function showAuthView() {
    showView('auth');
    switchAuthTab('login');
  }

  function bindAuthForms() {
    // Sekme tıklamaları
    $$('[data-rnw-auth-tab]').forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        switchAuthTab(t.getAttribute('data-rnw-auth-tab'));
      });
    });

    // Login form
    var loginForm = $('[data-rnw-auth-form="login"]');
    if (loginForm) loginForm.addEventListener('submit', function (e) {
      e.preventDefault();
      hideAllAuthErrors();
      var fd = new FormData(loginForm);
      var btn = loginForm.querySelector('button[type=submit]');
      btn.disabled = true; btn.textContent = (window.rnwT?window.rnwT('account.btn_signing_in',"Signing in..."):"Signing in...");
      api('/panel/buyer/api/login', {
        method: 'POST',
        body: { email: fd.get('email'), password: fd.get('password') }
      }).then(function (res) {
        btn.disabled = false; btn.textContent = (window.rnwT?window.rnwT('account.btn_signin_label',"Sign in"):"Sign in");
        if (!res.ok) {
          showAuthError('login', res.data.error || (window.rnwT?window.rnwT('account.error_signin_failed',"Sign in failed"):"Sign in failed"));
          if (res.data.needsPasswordSetup) {
            setTimeout(function () { switchAuthTab('forgot'); }, 1200);
          }
          return;
        }
        state.customer = res.data.customer;
        state.addresses = state.customer.addresses || [];
        showDashboard();
      });
    });

    // Register form — kurumsal alici basvurusu (alanlar renneway-register.js ile cizilir)
    var regForm = $('[data-rnw-auth-form="register"]');
    var regFields = $('[data-rnw-register-fields]');
    if (regFields && window.rnwRegister) window.rnwRegister.mount(regFields);
    if (regForm) regForm.addEventListener('submit', function (e) {
      e.preventDefault();
      hideAllAuthErrors();
      if (!window.rnwRegister) return;
      var body = window.rnwRegister.collect(regForm);
      var btn = regForm.querySelector('button[type=submit]');
      var btnLabel = window.rnwRegister.label('submit');
      btn.disabled = true; btn.textContent = window.rnwRegister.label('submitting');
      api('/panel/buyer/api/register', { method: 'POST', body: body }).then(function (res) {
        btn.disabled = false; btn.textContent = btnLabel;
        if (!res.ok) {
          showAuthError('register', res.data.error || (window.rnwT?window.rnwT('account.error_registration_failed',"Registration failed"):"Registration failed"));
          window.rnwRegister.markError(regForm, res.data.field);
          return;
        }
        window.rnwRegister.markError(regForm, null);
        state.customer = res.data.customer;
        state.addresses = state.customer.addresses || [];
        showDashboard();
      });
    });

    // Forgot form
    var forgotForm = $('[data-rnw-auth-form="forgot"]');
    if (forgotForm) forgotForm.addEventListener('submit', function (e) {
      e.preventDefault();
      hideAllAuthErrors();
      var fd = new FormData(forgotForm);
      var btn = forgotForm.querySelector('button[type=submit]');
      btn.disabled = true; btn.textContent = (window.rnwT?window.rnwT('common.sending',"Sending..."):"Sending...");
      api('/panel/buyer/api/password-reset/request', {
        method: 'POST',
        body: { email: fd.get('email') }
      }).then(function (res) {
        btn.disabled = false; btn.textContent = (window.rnwT?window.rnwT('account.btn_send_reset_link',"Send reset link"):"Send reset link");
        if (!res.ok) {
          showAuthError('forgot', res.data.error || (window.rnwT?window.rnwT('common.error_occurred',"An error occurred"):"An error occurred"));
          return;
        }
        showAuthSuccess('forgot');
        forgotForm.reset();
      });
    });
  }

  // ---- Reset password view (email linkinden gelir) ----

  function initResetView(email, token) {
    showView('reset');
    var emailEl = $('[data-rnw-reset-email]');
    if (emailEl) emailEl.textContent = email;
    $('[data-rnw-reset-email-input]').value = email;
    $('[data-rnw-reset-token-input]').value = token;
  }

  function bindResetForm() {
    var form = $('[data-rnw-reset-form]');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var errEl = $('[data-rnw-reset-err]');
      if (errEl) errEl.hidden = true;
      var fd = new FormData(form);
      if (fd.get('password') !== fd.get('passwordConfirm')) {
        if (errEl) { errEl.textContent = (window.rnwT?window.rnwT('account.error_passwords_mismatch',"Passwords do not match"):"Passwords do not match"); errEl.hidden = false; }
        return;
      }
      var btn = form.querySelector('button[type=submit]');
      btn.disabled = true; btn.textContent = (window.rnwT?window.rnwT('common.saving',"Saving..."):"Saving...");
      api('/panel/buyer/api/password-reset/confirm', {
        method: 'POST',
        body: {
          email: fd.get('email'), token: fd.get('token'),
          password: fd.get('password')
        }
      }).then(function (res) {
        btn.disabled = false; btn.textContent = (window.rnwT?window.rnwT('account.btn_save_password_label',"Save password"):"Save password");
        if (!res.ok) {
          if (errEl) { errEl.textContent = res.data.error || (window.rnwT?window.rnwT('common.error_occurred',"An error occurred"):"An error occurred"); errEl.hidden = false; }
          return;
        }
        state.customer = res.data.customer;
        state.addresses = state.customer.addresses || [];
        // URL'yi temizle
        try { window.history.replaceState(null, '', window.location.pathname); } catch (e) {}
        showDashboard();
      });
    });
  }

  // ---- Dashboard ----

  // Onay bekleyen / reddedilen aliciya durum bandi — fiyatlar yalnizca onayli hesaplara acik
  function renderApprovalBanner() {
    var el = $('[data-rnw-approval-banner]');
    if (!el) return;
    var access = state.customer && state.customer.priceAccess;
    if (!access || access === 'approved') { el.hidden = true; return; }
    var tr = isTurkish();
    var text = access === 'supplier'
      ? { t: tr ? 'Tedarikçi hesabı' : 'Supplier account',
          b: tr ? 'Mağazada yalnızca kendi tekliflerinizin fiyatlarını görürsünüz. Diğer tedarikçilerin fiyatları gizlidir; bu hesapla sipariş, pazarlık, numune veya talep oluşturulamaz.'
                : 'In the store you only see the prices of your own offers. Other suppliers\' prices are hidden; orders, negotiations, samples and requests cannot be created from this account.' }
      : access === 'rejected'
      ? { t: tr ? 'Hesabınız onaylanmadı' : 'Your account was not approved',
          b: tr ? 'Detaylar için bize e-postayla ulaşabilirsiniz.' : 'Please contact us by email for details.' }
      : { t: tr ? 'Hesabınız onay bekliyor' : 'Your account is awaiting approval',
          b: tr ? 'Firma bilgileriniz ekibimizce inceleniyor. Onaylandığında e-postayla haber vereceğiz; tedarikçi fiyatları ve sipariş o zaman açılır.'
                : 'Our team is reviewing your company details. We will email you once approved — supplier prices and ordering open then.' };
    el.classList.toggle('is-rejected', access === 'rejected');
    $('[data-rnw-approval-title]').textContent = text.t;
    $('[data-rnw-approval-body]').textContent = text.b;
    el.hidden = false;
  }

  function showDashboard() {
    showView('dashboard');
    renderUserCard();
    renderApprovalBanner();
    if (window.rnwCart) window.rnwCart.refreshBadge();

    // Stats için orders'ı arka planda yükle (her sekme açıldığında stats güncellenir)
    if (state.orders.length === 0) {
      api('/panel/buyer/api/orders').then(function (res) {
        if (res.ok) {
          state.orders = res.data.orders || [];
          renderStats();
          // Eğer orders tab açıksa listeyi de yenile
          var ordersTab = $('[data-rnw-tab="orders"]');
          if (ordersTab && !ordersTab.hidden) renderOrdersList();
        }
      });
    } else {
      renderStats();
    }

    // İlk tab — URL hash'i varsa kullan; #negotiations/<id> deep-link de işlenir
    var rawHash = window.location.hash || '';
    var negMatchInit = rawHash.match(/^#negotiations\/([a-fA-F0-9]{24})$/);
    if (negMatchInit) {
      switchDashboardTab('negotiation-detail');
      openNegotiationDetail(negMatchInit[1]);
      return;
    }
    var hash = rawHash.replace('#', '');
    var validTabs = ['orders','cart','addresses','settings','negotiations','samples','rfqs'];
    var tab = validTabs.indexOf(hash) >= 0 ? hash : 'orders';
    switchDashboardTab(tab);
  }

  function renderUserCard() {
    var c = state.customer;
    var displayEl = $('[data-rnw-user-display]');
    var emailDispEl = $('[data-rnw-user-email-display]');
    var greetEl = $('[data-rnw-time-greeting]');
    var nameEl = $('[data-rnw-user-name]');
    var emailEl = $('[data-rnw-user-email]');

    var fn = firstName(c.name);
    if (displayEl) {
      displayEl.innerHTML = fn
        ? (window.rnwT ? window.rnwT('account.hello','Hello') : 'Hello') + ' <em>' + escapeHtml(fn) + '</em>'
        : 'Welcome <em>back</em>';
    }
    if (emailDispEl) {
      emailDispEl.textContent = (c.companyName ? c.companyName + ' · ' : '') + c.email;
    }
    if (greetEl) greetEl.textContent = timeGreeting();
    if (nameEl) nameEl.textContent = c.name || c.email;
    if (emailEl) emailEl.textContent = c.email;
  }

  function renderStats() {
    var orders = state.orders || [];
    var counted = orders.filter(function (o) { return isCountedOrder(o.status); });
    var totalCount = counted.length;
    var totalSpent = counted.reduce(function (s, o) { return s + Number((o.pricing && o.pricing.total) || 0); }, 0);
    var activeCount = orders.filter(function (o) { return isActiveOrder(o.status); }).length;
    var lastOrder = orders.length > 0 ? orders[0] : null;

    var ordersEl = $('[data-rnw-stat-orders]');
    var spentEl = $('[data-rnw-stat-spent]');
    var activeEl = $('[data-rnw-stat-active]');
    var lastEl = $('[data-rnw-stat-last]');

    if (ordersEl) ordersEl.textContent = totalCount;
    if (spentEl) spentEl.textContent = totalSpent > 0 ? '$' + Math.round(totalSpent).toLocaleString('tr-TR') : '$0';
    if (activeEl) activeEl.textContent = activeCount;
    if (lastEl) lastEl.textContent = lastOrder ? fmtDate(lastOrder.createdAt) : '—';
  }

  function bindDashboard() {
    // Sidebar tab linkleri
    $$('[data-rnw-tab-link]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        switchDashboardTab(el.getAttribute('data-rnw-tab-link'));
      });
    });
    // Logout
    var logoutBtn = $('[data-rnw-logout]');
    if (logoutBtn) logoutBtn.addEventListener('click', function (e) {
      e.preventDefault();
      api('/panel/buyer/api/logout', { method: 'POST' }).then(function () {
        if (window.rnwToken) window.rnwToken.set('');
        state.customer = null; state.addresses = []; state.orders = [];
        if (window.rnwCart) window.rnwCart.refreshBadge();
        // Auth formlarını sıfırla
        $$('[data-rnw-auth-form]').forEach(function (f) { f.reset(); });
        showAuthView();
      });
    });

    // Address form
    var addrForm = $('[data-rnw-addr-form]');
    if (addrForm) addrForm.addEventListener('submit', function (e) {
      e.preventDefault();
      submitAddressForm();
    });

    // Settings form
    var setForm = $('[data-rnw-settings-form]');
    if (setForm) setForm.addEventListener('submit', function (e) {
      e.preventDefault();
      submitSettingsForm();
    });

    // Sefer tarifeleri formu
    var schedForm = $('[data-rnw-sched-form]');
    if (schedForm) schedForm.addEventListener('submit', function (e) {
      e.preventDefault();
      submitScheduleSearch();
    });

    // Order detail back
    var orderBack = $('[data-rnw-order-back]');
    if (orderBack) orderBack.addEventListener('click', function () {
      switchDashboardTab('orders');
    });

    // Hash değişimi (browser back/forward)
    window.addEventListener('hashchange', function () {
      if (!state.customer) return;
      var hash = (window.location.hash || '').replace('#', '');
      var validTabs = ['orders','cart','addresses','settings','negotiations','samples','rfqs'];
      if (validTabs.indexOf(hash) >= 0) switchDashboardTab(hash);
      // Deep-link: #negotiations/<id>
      var negMatch = window.location.hash.match(/^#negotiations\/([a-fA-F0-9]{24})$/);
      if (negMatch) {
        switchDashboardTab('negotiation-detail');
        openNegotiationDetail(negMatch[1]);
      }
    });
  }

  function switchDashboardTab(tab) {
    showTab(tab);
    if (tab === 'orders') {
      loadOrders();
      if (window.rnwCart) window.rnwCart.mountPending($('[data-rnw-pending-transfers]'));
    }
    else if (tab === 'cart') { if (window.rnwCart) window.rnwCart.mount($('[data-rnw-cart-root]'), { customer: state.customer }); }
    else if (tab === 'addresses') renderAddresses();
    else if (tab === 'settings') renderSettings();
    else if (tab === 'negotiations') loadNegotiations();
    else if (tab === 'samples') loadSamples();
    else if (tab === 'rfqs') loadRfqs();
    else if (tab === 'schedules') loadSchedulePorts();
  }

  // ---- Sefer tarifeleri (Hapag Commercial Schedules) ----

  var schedPortsLoaded = false;

  // Standart kuru yuk konteyneri icin anlamli son kabul zamanlari.
  // Diger DCSA kodlari (reefer, tehlikeli madde, gabari disi) iplik sevkiyatinda gosterilmez.
  var CUTOFF_LABELS = {
    FCO: { tr: 'Yük', en: 'Cargo' },
    DCO: { tr: 'Belge', en: 'Documentation' },
    VCO: { tr: 'VGM', en: 'VGM' }
  };
  var CUTOFF_ORDER = ['DCO', 'VCO', 'FCO'];

  function loadSchedulePorts() {
    if (schedPortsLoaded) return;
    var listEl = $('[data-rnw-sched-ports]');
    if (!listEl) return;
    api('/panel/buyer/api/schedules/ports').then(function (res) {
      if (!res.ok || !res.data || !Array.isArray(res.data.ports)) return;
      schedPortsLoaded = true;
      var tr = isTurkish();
      listEl.innerHTML = res.data.ports.map(function (p) {
        return '<option value="' + escapeHtml(p.code) + '">' + escapeHtml(tr ? p.tr : p.en) + '</option>';
      }).join('');
    });
  }

  function schedModeLabel(mode) {
    var tr = isTurkish();
    if (mode === 'VESSEL') return tr ? 'Gemi' : 'Vessel';
    if (mode === 'BARGE') return tr ? 'Mavna' : 'Barge';
    if (mode === 'RAIL') return tr ? 'Tren' : 'Rail';
    if (mode === 'TRUCK') return tr ? 'Kamyon' : 'Truck';
    return mode || '—';
  }

  function renderScheduleRoutes(routes) {
    var box = $('[data-rnw-sched-results]');
    if (!box) return;
    var t = function (k, fb) { return _t('account.' + k, fb); };

    if (!routes.length) {
      box.innerHTML = '<div class="rnw-acc-empty"><div class="rnw-acc-empty__desc">' +
        escapeHtml(t('sched_none', 'No sailings found for this route. Try another date or port.')) + '</div></div>';
      return;
    }

    box.innerHTML = routes.map(function (r) {
      var badge = r.transhipments === 0
        ? '<span class="rnw-sched-badge is-direct">' + escapeHtml(t('sched_direct', 'Direct')) + '</span>'
        : '<span class="rnw-sched-badge is-ts">' + r.transhipments + ' ' + escapeHtml(t('sched_transhipment', 'transhipment')) + '</span>';

      var legs = (r.legs || []).map(function (l) {
        var vesselLine = l.vesselName
          ? '<div class="rnw-sched-leg__vessel">' + escapeHtml(l.vesselName) +
              (l.voyageNumber ? ' · ' + escapeHtml(l.voyageNumber) : '') +
              (l.serviceName ? ' <span class="rnw-sched-leg__svc">(' + escapeHtml(l.serviceName) + ')</span>' : '') +
            '</div>'
          : '';
        return '<div class="rnw-sched-leg">' +
          '<div class="rnw-sched-leg__mode">' + escapeHtml(schedModeLabel(l.mode)) + '</div>' +
          '<div class="rnw-sched-leg__main">' +
            vesselLine +
            '<div class="rnw-sched-leg__path' + (vesselLine ? '' : ' is-solo') + '">' +
              escapeHtml(l.from.name || l.from.code || '—') + ' ' + (l.from.dateTime ? fmtDate(l.from.dateTime, true) : '') +
              ' → ' +
              escapeHtml(l.to.name || l.to.code || '—') + ' ' + (l.to.dateTime ? fmtDate(l.to.dateTime, true) : '') +
            '</div>' +
          '</div>' +
        '</div>';
      }).join('');

      var cuts = (r.cutOffTimes || []).filter(function (c) {
        return c.dateTime && CUTOFF_LABELS[c.code];
      });
      cuts.sort(function (a, b) { return CUTOFF_ORDER.indexOf(a.code) - CUTOFF_ORDER.indexOf(b.code); });
      var cutHtml = cuts.length
        ? '<div class="rnw-sched-cutoff">' + escapeHtml(t('sched_cutoff', 'Cut-off')) + ' — ' +
            cuts.map(function (c) {
              var l = CUTOFF_LABELS[c.code];
              return escapeHtml(isTurkish() ? l.tr : l.en) + ': ' + fmtDate(c.dateTime, true);
            }).join(' · ') +
          '</div>'
        : '';

      return '<div class="rnw-acc-card rnw-sched-card">' +
        '<div class="rnw-sched-head">' +
          '<div class="rnw-sched-route">' +
            '<strong>' + escapeHtml(r.origin.name || r.origin.code) + '</strong>' +
            '<span class="rnw-sched-arrow">→</span>' +
            '<strong>' + escapeHtml(r.destination.name || r.destination.code) + '</strong>' +
            badge +
          '</div>' +
          (r.transitTime != null
            ? '<div class="rnw-sched-transit">' + escapeHtml(t('sched_transit', 'Transit')) + ': <strong>' +
              r.transitTime + ' ' + escapeHtml(t('sched_days', 'days')) + '</strong></div>'
            : '') +
        '</div>' +
        '<div class="rnw-sched-dates">' +
          (r.departure ? escapeHtml(t('sched_departure', 'Departure')) + ': <strong>' + fmtDate(r.departure, true) + '</strong>' : '') +
          (r.arrival ? ' · ' + escapeHtml(t('sched_arrival', 'Arrival')) + ': <strong>' + fmtDate(r.arrival, true) + '</strong>' : '') +
        '</div>' +
        (legs ? '<div class="rnw-sched-legs">' + legs + '</div>' : '') +
        cutHtml +
      '</div>';
    }).join('') +
    '<div class="rnw-sched-credit">' + escapeHtml(_t('account.sched_by_hapag', 'Schedule data by Hapag-Lloyd')) + '</div>';
  }

  function fmtNum(n) {
    return Number(n || 0).toLocaleString(isTurkish() ? 'tr-TR' : 'en-GB');
  }

  function fmtUsd(n, decimals) {
    var d = decimals == null ? 2 : decimals;
    var v = Number(n || 0);
    return '$' + v.toLocaleString(isTurkish() ? 'tr-TR' : 'en-GB', { minimumFractionDigits: d, maximumFractionDigits: d });
  }

  function renderFreight(est, kg) {
    var box = $('[data-rnw-sched-freight]');
    if (!box) return;
    var t = function (k, fb) { return _t('account.' + k, fb); };
    if (!est) { box.innerHTML = ''; return; }

    var lines = [];
    lines.push(escapeHtml(t('frg_basis', 'Based on')) + ' <strong>' + escapeHtml(est.containerCode) + '</strong> · ' +
      escapeHtml(t('frg_capacity', 'capacity')) + ' <strong>' + fmtNum(est.containerCapacityKg) + ' kg</strong> · ' +
      escapeHtml(t('frg_container_total', 'container total')) + ' <strong>' + fmtUsd(est.containerTotalUsd) + '</strong>');
    if (est.fullContainers > 0) {
      lines.push(est.fullContainers + ' ' + escapeHtml(t('frg_full', 'full container(s)')) +
        (est.remainderKg > 0 ? ' + ' + fmtNum(est.remainderKg) + ' kg ' + escapeHtml(t('frg_remainder', 'remaining')) : ''));
    }
    if (est.transitTime != null) {
      lines.push(escapeHtml(t('sched_transit', 'Transit')) + ': <strong>' + est.transitTime + ' ' + escapeHtml(t('sched_days', 'days')) + '</strong>');
    }
    if (est.validTo) {
      lines.push(escapeHtml(t('frg_valid', 'Offer valid until')) + ': ' + fmtDate(est.validTo, true));
    }

    box.innerHTML =
      '<div class="rnw-acc-card rnw-frg">' +
        '<div class="rnw-frg__top">' +
          '<div>' +
            '<div class="rnw-acc-card__label">' + escapeHtml(t('frg_title', 'Estimated freight')) + '</div>' +
            '<div class="rnw-frg__route">' + fmtNum(kg) + ' kg · ' +
              escapeHtml($('#rnw-sched-from').value) + ' → ' + escapeHtml($('#rnw-sched-to').value) + '</div>' +
          '</div>' +
          '<div class="rnw-frg__amount">' +
            '<div class="rnw-frg__total">' + fmtUsd(est.totalUsd) + '</div>' +
            '<div class="rnw-frg__perkg">' + escapeHtml(t('frg_per_kg', 'per kg')) + ' ' + fmtUsd(est.perKgUsd, 4) + '</div>' +
          '</div>' +
        '</div>' +
        '<div class="rnw-frg__meta">' + lines.join('<br>') + '</div>' +
        (est.isPartialLoad
          ? '<div class="rnw-frg__note">' + escapeHtml(t('frg_partial', 'This quantity does not fill a container.')) + '</div>'
          : '') +
      '</div>';
  }

  function loadFreight(from, to, kg, date) {
    var box = $('[data-rnw-sched-freight]');
    if (!box) return;
    var t = function (k, fb) { return _t('account.' + k, fb); };
    box.innerHTML = '<div class="rnw-acc-card rnw-frg rnw-frg--loading">' +
      escapeHtml(_t('common.loading', 'Loading')) + '</div>';

    var qs = '?from=' + encodeURIComponent(from) + '&to=' + encodeURIComponent(to) +
      '&kg=' + encodeURIComponent(kg) + (date ? '&date=' + encodeURIComponent(date) : '');

    api('/panel/buyer/api/freight-estimate' + qs).then(function (res) {
      if (!res.ok || !res.data) {
        box.innerHTML = '<div class="rnw-acc-card rnw-frg rnw-frg--loading">' +
          escapeHtml(t('frg_error', 'Freight estimate unavailable right now.')) + '</div>';
        return;
      }
      if (!res.data.estimate) {
        box.innerHTML = '<div class="rnw-acc-card rnw-frg rnw-frg--loading">' +
          escapeHtml(t('frg_none', 'No freight price for this route.')) + '</div>';
        return;
      }
      renderFreight(res.data.estimate, kg);
    });
  }

  function submitScheduleSearch() {
    var box = $('[data-rnw-sched-results]');
    var btn = $('[data-rnw-sched-submit]');
    var fromEl = $('#rnw-sched-from');
    var toEl = $('#rnw-sched-to');
    var dateEl = $('#rnw-sched-date');
    var kgEl = $('#rnw-sched-kg');
    if (!box || !fromEl || !toEl) return;

    var t = function (k, fb) { return _t('account.' + k, fb); };
    var from = (fromEl.value || '').trim().toUpperCase();
    var to = (toEl.value || '').trim().toUpperCase();
    var date = dateEl ? (dateEl.value || '').trim() : '';
    fromEl.value = from;
    toEl.value = to;

    var valid = /^[A-Z]{2}[A-Z2-9]{3}$/;
    if (!valid.test(from) || !valid.test(to)) {
      box.innerHTML = '<div class="rnw-acc-empty"><div class="rnw-acc-empty__desc">' +
        escapeHtml(t('sched_hint', 'Pick a port from the list or type a 5-letter UN/LOCODE.')) + '</div></div>';
      return;
    }
    if (from === to) {
      box.innerHTML = '<div class="rnw-acc-empty"><div class="rnw-acc-empty__desc">' +
        escapeHtml(t('sched_same_port', 'Departure and arrival ports must be different.')) + '</div></div>';
      return;
    }

    var originalLabel = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = t('sched_searching', 'Searching...'); }
    box.innerHTML = '<div class="rnw-acc-loading"><div class="rnw-acc-loading__spin"></div><div>' +
      escapeHtml(_t('common.loading', 'Loading')) + '</div></div>';

    var kg = kgEl ? Number(kgEl.value) : 0;
    var freightBox = $('[data-rnw-sched-freight]');
    if (freightBox) freightBox.innerHTML = '';
    if (kg > 0) loadFreight(from, to, kg, date);

    var qs = '?from=' + encodeURIComponent(from) + '&to=' + encodeURIComponent(to) +
      (date ? '&date=' + encodeURIComponent(date) : '');

    api('/panel/buyer/api/schedules' + qs).then(function (res) {
      if (btn) { btn.disabled = false; btn.textContent = originalLabel; }
      if (!res.ok || !res.data || !Array.isArray(res.data.routes)) {
        box.innerHTML = '<div class="rnw-acc-empty"><div class="rnw-acc-empty__desc">' +
          escapeHtml(t('sched_error', 'Could not load sailings. Please try again.')) + '</div></div>';
        return;
      }
      renderScheduleRoutes(res.data.routes);
    });
  }

  // ---- Orders ----

  function loadOrders() {
    var listEl = $('[data-rnw-orders-list]');
    if (!listEl) return;
    if (state.orders.length > 0 && state.requestsLoaded) { renderOrdersList(); return; }
    listEl.innerHTML = '<div class="rnw-acc-loading"><div class="rnw-acc-loading__spin"></div><div>' + (window.rnwT?window.rnwT('common.loading',"Loading"):"Loading") + '</div></div>';
    Promise.all([
      state.orders.length > 0 ? Promise.resolve({ ok: true, data: { orders: state.orders } }) : api('/panel/buyer/api/orders'),
      api('/panel/buyer/api/order-requests')
    ]).then(function (results) {
      var ordersRes = results[0];
      var reqRes = results[1];
      if (!ordersRes.ok) {
        listEl.innerHTML = '<div class="rnw-acc-empty"><div class="rnw-acc-empty__title">Something went wrong</div><div class="rnw-acc-empty__desc">Orders could not be loaded. Please refresh the page.</div></div>';
        return;
      }
      state.orders = ordersRes.data.orders || [];
      // Group requests by orderId for fast lookup
      var byOrder = {};
      if (reqRes.ok && Array.isArray(reqRes.data.requests)) {
        reqRes.data.requests.forEach(function (r) {
          var k = String(r.orderId);
          (byOrder[k] = byOrder[k] || []).push(r);
        });
      }
      state.requestsByOrderId = byOrder;
      state.requestsLoaded = true;
      renderStats();
      // TR locale ise once product title'lari ceviripoutput verir; EN'de no-op
      applyTRTitlesToOrders().then(function () {
        renderOrdersList();
      });
    });
  }

  function renderOrdersList() {
    var listEl = $('[data-rnw-orders-list]');
    if (!listEl) return;
    if (state.orders.length === 0) {
      listEl.innerHTML = '<div class="rnw-acc-empty">' +
        '<div class="rnw-acc-empty__icon">' +
          '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16v16l-3-2-3 2-3-2-3 2-3-2z"/><path d="M8 9h8"/><path d="M8 13h8"/></svg>' +
        '</div>' +
        '<div class="rnw-acc-empty__title">No orders yet</div>' +
        '<div class="rnw-acc-empty__desc">Your first order will appear here. Go back to the homepage to explore products.</div>' +
        '<a href="/" class="rnw-acc-btn rnw-acc-btn--sm">Explore products</a>' +
        '</div>';
      return;
    }

    var cards = state.orders.map(function (o) {
      var p = o.productSnapshot || {};
      var pricing = o.pricing || {};
      var rqs = (state.requestsByOrderId && state.requestsByOrderId[String(o.id)]) || [];
      var st = effectiveStatusInfo(o, rqs);
      var t = function (k, fb) { return window.rnwT ? window.rnwT('account.' + k, fb) : fb; };

      // Havale ile odenen ve odeme bekleyen siparis: banka bilgisi + "Havaleyi yaptim"
      var bankHtml = '';
      if (o.paymentMethod === 'bank_transfer' && o.status === 'pending_payment' && !o.checkoutId) {
        if (o.transferDeclaredAt) {
          bankHtml = '<div class="rnw-acc-smp-bank" style="margin-top:8px">' +
            '<div class="rnw-acc-smp-bank__title">' + escapeHtml(t('order_transfer_declared', 'Transfer declared — waiting for supplier confirmation')) + '</div>' +
            '</div>';
        } else if (o.bankInfo) {
          var b = o.bankInfo;
          bankHtml =
            '<div class="rnw-acc-smp-bank" style="margin-top:8px">' +
              '<div class="rnw-acc-smp-bank__title">' + escapeHtml(t('sample_bank_title', 'Bank transfer details')) + '</div>' +
              (b.bankName ? '<div><span class="lbl">Banka:</span> <strong>' + escapeHtml(b.bankName) + (b.branch ? ' / ' + escapeHtml(b.branch) : '') + '</strong></div>' : '') +
              (b.accountHolder ? '<div><span class="lbl">Alıcı:</span> <strong>' + escapeHtml(b.accountHolder) + '</strong></div>' : '') +
              '<div><span class="lbl">IBAN:</span> <strong style="user-select:all">' + escapeHtml(b.iban) + '</strong></div>' +
              (pricing.totalTRY ? '<div><span class="lbl">' + escapeHtml(t('sample_fee', 'Amount')) + ':</span> <strong>' + Number(pricing.totalTRY).toLocaleString('tr-TR') + ' TL</strong></div>' : '') +
              '<div class="lbl" style="margin-top:4px">' + escapeHtml(t('sample_ref_note', 'Reference')) + ': <strong>' + escapeHtml(o.orderNumber) + '</strong></div>' +
            '</div>' +
            '<div class="rnw-acc-smp-actions">' +
              '<button type="button" class="rnw-acc-btn rnw-acc-btn--primary" data-rnw-order-paid="' + escapeHtml(o.id) + '">' + escapeHtml(t('sample_mark_paid', 'I made the transfer')) + '</button>' +
            '</div>';
        }
      }

      return (
        '<div class="rnw-acc-order-card" data-rnw-order-id="' + escapeHtml(o.id) + '" role="button" tabindex="0">' +
          '<div class="rnw-acc-order-card__left">' +
            '<div class="rnw-acc-order-card__top">' +
              '<span class="rnw-acc-order-no">' + escapeHtml(o.orderNumber) + '</span>' +
              '<span class="rnw-acc-order-date">' + fmtDate(o.createdAt) + '</span>' +
            '</div>' +
            '<div class="rnw-acc-order-title">' + escapeHtml(p.titleDisplay || p.title || '—') + '</div>' +
            '<div class="rnw-acc-order-meta">' +
              '<span><strong>' + (window.rnwT?window.rnwT('account.label_number','Number'):'Number') + ':</strong> ' + escapeHtml(p.number || '—') + '</span>' +
              '<span><strong>' + (window.rnwT?window.rnwT('account.label_color','Color'):'Color') + ':</strong> ' + escapeHtml(p.color || '—') + '</span>' +
              '<span><strong>' + (window.rnwT?window.rnwT('account.label_quantity','Quantity'):'Quantity') + ':</strong> ' + (pricing.kg || 0) + ' kg</span>' +
            '</div>' +
            bankHtml +
          '</div>' +
          '<div class="rnw-acc-order-card__right">' +
            '<span class="rnw-acc-badge" style="' + st.style + '">' + escapeHtml(st.label) + '</span>' +
            '<div class="rnw-acc-order-amount">' + money(pricing.total, pricing.currency) + '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    listEl.innerHTML = '<div class="rnw-acc-order-list">' + cards + '</div>';

    $$('[data-rnw-order-id]', listEl).forEach(function (card) {
      var open = function () { openOrderDetail(card.getAttribute('data-rnw-order-id')); };
      card.addEventListener('click', open);
      card.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
    });

    $$('[data-rnw-order-paid]', listEl).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var t2 = function (k, fb) { return window.rnwT ? window.rnwT('account.' + k, fb) : fb; };
        if (!confirm(t2('sample_paid_confirm', 'Confirm that you made the bank transfer?'))) return;
        btn.disabled = true;
        api('/panel/buyer/api/orders/' + btn.getAttribute('data-rnw-order-paid') + '/transfer-declared', { method: 'POST', body: {} }).then(function (res) {
          if (res.ok) { state.orders = []; state.requestsLoaded = false; loadOrders(); }
          else { btn.disabled = false; alert(res.data.error || 'Error'); }
        });
      });
    });
  }

  function openOrderDetail(orderId) {
    state.currentOrderId = orderId;
    switchDashboardTab('order-detail');
    var detailEl = $('[data-rnw-order-detail]');
    if (!detailEl) return;
    detailEl.innerHTML = '<div class="rnw-acc-loading"><div class="rnw-acc-loading__spin"></div><div>' + (window.rnwT?window.rnwT('common.loading',"Loading"):"Loading") + '</div></div>';
    Promise.all([
      api('/panel/buyer/api/orders/' + orderId),
      api('/panel/buyer/api/order-requests')
    ]).then(function (results) {
      var orderRes = results[0];
      var reqRes = results[1];
      if (!orderRes.ok) {
        detailEl.innerHTML = '<div class="rnw-acc-err">Order not found</div>';
        return;
      }
      var requestsForOrder = ((reqRes.ok && reqRes.data.requests) || []).filter(function (r) {
        return String(r.orderId) === String(orderId);
      });
      // keep list cache in sync so list view shows the latest status without a roundtrip
      if (state.requestsByOrderId) state.requestsByOrderId[String(orderId)] = requestsForOrder;
      renderOrderDetail(orderRes.data.order, requestsForOrder);
    });
  }

  // ---- Hapag-Lloyd konteyner takibi ----

  var TRK_LABELS = {
    LOAD: { tr: 'Gemiye yüklendi',        en: 'Loaded on vessel' },
    DISC: { tr: 'Gemiden indirildi',      en: 'Discharged from vessel' },
    GTIN: { tr: 'Terminale giriş yaptı',  en: 'Gate in at terminal' },
    GTOT: { tr: 'Terminalden çıkış yaptı', en: 'Gate out from terminal' },
    STUF: { tr: 'Konteyner dolduruldu',   en: 'Container stuffed' },
    STRP: { tr: 'Konteyner boşaltıldı',   en: 'Container stripped' },
    PICK: { tr: 'Teslim alındı',          en: 'Picked up' },
    DROP: { tr: 'Bırakıldı',              en: 'Dropped off' },
    ARRI: { tr: 'Varış',                  en: 'Arrival' },
    DEPA: { tr: 'Kalkış',                 en: 'Departure' },
    RECE: { tr: 'Belge alındı',           en: 'Document received' },
    ISSU: { tr: 'Belge düzenlendi',       en: 'Document issued' },
    CONF: { tr: 'Onaylandı',              en: 'Confirmed' },
    APPR: { tr: 'Onaylandı',              en: 'Approved' },
    SUBM: { tr: 'Belge iletildi',         en: 'Document submitted' },
    RELS: { tr: 'Serbest bırakıldı',      en: 'Released' }
  };

  // Aktif dil Liquid'den gelir (request.locale.iso_code). document.documentElement.lang
  // magazanin varsayilan dilini gosterebiliyor ve ingilizce sayfada 'tr' kalabiliyor.
  function isTurkish() {
    var lang = _t('common.lang', '');
    if (!lang) lang = document.documentElement.lang || '';
    return String(lang).toLowerCase().indexOf('tr') === 0;
  }

  function trkEventName(ev) {
    var l = TRK_LABELS[ev.code];
    if (!l) return ev.code || '';
    return isTurkish() ? l.tr : l.en;
  }

  var TRK_STATUS = {
    booked:     { key: 'trk_st_booked',     fb: 'Booked' },
    at_origin:  { key: 'trk_st_at_origin',  fb: 'At origin port' },
    in_transit: { key: 'trk_st_in_transit', fb: 'In transit' },
    arrived:    { key: 'trk_st_arrived',    fb: 'Arrived' }
  };

  // Ayni damgayi tasiyan olaylarin mantiksal sirasi (services/hapag.js ile ayni).
  var TRK_SEQUENCE = {
    ISSU: 0, RECE: 1, SUBM: 2, CONF: 3, APPR: 4, RELS: 5,
    PICK: 8, GTIN: 10, STUF: 15, LOAD: 20, DEPA: 30,
    ARRI: 40, DISC: 50, STRP: 55, GTOT: 60, DROP: 70
  };
  function trkOrder(ev) {
    var s = TRK_SEQUENCE[ev.code];
    return s === undefined ? 35 : s;
  }

  // Sunucu journey gondermezse (eski onbellek, mobil vs.) ayni gruplama burada yapilir.
  function trkBuildJourney(events, trk) {
    var list = (events || []).filter(function (e) { return e.dateTime; }).slice()
      .sort(function (a, b) {
        return new Date(a.dateTime) - new Date(b.dateTime) || trkOrder(a) - trkOrder(b);
      });
    var stops = [];
    var documents = [];
    list.forEach(function (ev) {
      var key = ev.unLocationCode || ev.locationName || '';
      if (!key) { documents.push(ev); return; }
      var last = stops[stops.length - 1];
      if (last && last.key === key) { last.events.push(ev); return; }
      stops.push({
        key: key,
        unLocationCode: ev.unLocationCode || '',
        locationName: ev.locationName || ev.unLocationCode || '',
        vesselName: ev.vesselName || '',
        voyageNumber: ev.voyageNumber || '',
        events: [ev]
      });
    });
    stops.forEach(function (s) {
      if (!s.vesselName) {
        var wv = s.events.filter(function (e) { return e.vesselName; })[0];
        if (wv) { s.vesselName = wv.vesselName; s.voyageNumber = wv.voyageNumber || ''; }
      }
      s.from = s.events[0].dateTime;
      s.to = s.events[s.events.length - 1].dateTime;
      var act = s.events.filter(function (e) { return e.classifier === 'ACT'; }).length;
      s.state = act === s.events.length ? 'done' : (act > 0 ? 'current' : 'upcoming');
    });
    var hasDep = list.some(function (e) { return e.code === 'DEPA' && e.classifier === 'ACT'; });
    var hasArr = list.some(function (e) { return e.code === 'ARRI' && e.classifier === 'ACT'; });
    var hasLoad = list.some(function (e) { return (e.code === 'LOAD' || e.code === 'GTIN') && e.classifier === 'ACT'; });
    var status = 'booked';
    if ((trk && trk.arrivedAt) || hasArr) status = 'arrived';
    else if (hasDep) status = 'in_transit';
    else if (hasLoad) status = 'at_origin';
    var eta = trk && trk.eta ? new Date(trk.eta) : null;
    var progress = 0;
    if (status === 'arrived') progress = 100;
    else if (stops.length) {
      var done = stops.filter(function (s) { return s.state === 'done'; }).length;
      var partial = stops.some(function (s) { return s.state === 'current'; }) ? 0.5 : 0;
      progress = Math.min(95, Math.round(((done + partial) / stops.length) * 100));
    }
    return {
      status: status,
      overdue: !!(status !== 'arrived' && eta && eta.getTime() < Date.now()),
      stops: stops,
      documents: documents,
      origin: stops[0] || null,
      destination: stops.length > 1 ? stops[stops.length - 1] : null,
      progress: progress
    };
  }

  function buildTrackingHtml(o) {
    var trk = o.tracking;
    if (!trk) return '';
    var events = (trk.events || []).filter(function (e) { return e.dateTime; });
    if (!trk.active && events.length === 0) return '';

    var t = function (k, fb) { return _t('account.' + k, fb); };
    var j = trk.journey && trk.journey.stops ? trk.journey : trkBuildJourney(events, trk);

    // --- Baslik: referanslar + durum rozeti ---
    var refs = [];
    if (trk.equipmentReference) {
      refs.push('<span class="rnw-trk-ref"><span class="lbl">' + escapeHtml(t('trk_container', 'Container')) +
        '</span><strong class="rnw-acc-mono">' + escapeHtml(trk.equipmentReference) + '</strong></span>');
    }
    if (trk.carrierBookingReference) {
      refs.push('<span class="rnw-trk-ref"><span class="lbl">' + escapeHtml(t('trk_booking', 'Booking')) +
        '</span><strong class="rnw-acc-mono">' + escapeHtml(trk.carrierBookingReference) + '</strong></span>');
    }

    var st = TRK_STATUS[j.status] || TRK_STATUS.booked;
    var badge = '<span class="rnw-trk-badge is-' + escapeHtml(j.status) + '">' +
      escapeHtml(t(st.key, st.fb)) + '</span>';

    // --- Rota seridi ---
    var routeHtml = '';
    if (j.origin && j.destination) {
      routeHtml =
        '<div class="rnw-trk-route">' +
          '<div class="rnw-trk-route__port">' +
            '<div class="rnw-trk-route__name">' + escapeHtml(j.origin.locationName) + '</div>' +
            (j.origin.unLocationCode ? '<div class="rnw-trk-route__code">' + escapeHtml(j.origin.unLocationCode) + '</div>' : '') +
          '</div>' +
          '<div class="rnw-trk-route__line">' +
            '<div class="rnw-trk-route__fill' + (j.status === 'arrived' ? ' is-done' : '') + '" style="width:' + j.progress + '%"></div>' +
            (j.status === 'booked' ? '' :
              '<span class="rnw-trk-route__ship" style="left:' + j.progress + '%">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">' +
                '<path d="M3 18a2.4 2.4 0 0 0 2 1 2.4 2.4 0 0 0 2-1 2.4 2.4 0 0 1 2-1 2.4 2.4 0 0 1 2 1 2.4 2.4 0 0 0 2 1 2.4 2.4 0 0 0 2-1 2.4 2.4 0 0 1 2-1 2.4 2.4 0 0 1 2 1"/>' +
                '<path d="M5 16l-1-5h16l-2 4"/><path d="M6 11V6h7l3 5"/></svg>' +
              '</span>') +
          '</div>' +
          '<div class="rnw-trk-route__port rnw-trk-route__port--end">' +
            '<div class="rnw-trk-route__name">' + escapeHtml(j.destination.locationName) + '</div>' +
            (j.destination.unLocationCode ? '<div class="rnw-trk-route__code">' + escapeHtml(j.destination.unLocationCode) + '</div>' : '') +
          '</div>' +
        '</div>';
    }

    // --- Varis kutusu ---
    var etaHtml = '';
    if (trk.arrivedAt) {
      etaHtml = '<div class="rnw-trk-eta is-done">' +
        '<span class="rnw-trk-eta__lbl">' + escapeHtml(t('trk_arrived', 'Arrived')) + '</span>' +
        '<span class="rnw-trk-eta__val">' + fmtDate(trk.arrivedAt, true) + '</span></div>';
    } else if (trk.eta) {
      etaHtml = '<div class="rnw-trk-eta' + (j.overdue ? ' is-late' : '') + '">' +
        '<span class="rnw-trk-eta__lbl">' + escapeHtml(t('trk_eta', 'Estimated arrival')) + '</span>' +
        '<span class="rnw-trk-eta__val">' + fmtDate(trk.eta, true) + '</span>' +
        (j.overdue ? '<span class="rnw-trk-eta__note">' + escapeHtml(t('trk_overdue', 'Past estimated arrival')) + '</span>' : '') +
        '</div>';
    }

    // --- Duraklar ---
    var stopsHtml = j.stops.map(function (s) {
      var rows = s.events.map(function (ev) {
        var estimated = ev.classifier !== 'ACT';
        return '<div class="rnw-trk-ev' + (estimated ? ' is-est' : '') + '">' +
          '<span class="rnw-trk-ev__name">' + escapeHtml(trkEventName(ev)) +
            (estimated ? ' <em>(' + escapeHtml(t('trk_estimated', 'estimated')) + ')</em>' : '') + '</span>' +
          '<span class="rnw-trk-ev__time">' + fmtDate(ev.dateTime, true) + '</span>' +
        '</div>';
      }).join('');

      return '<li class="rnw-trk-stop is-' + escapeHtml(s.state) + '">' +
        '<div class="rnw-trk-stop__head">' +
          '<div class="rnw-trk-stop__port">' + escapeHtml(s.locationName) +
            (s.unLocationCode ? ' <span class="rnw-trk-stop__code">' + escapeHtml(s.unLocationCode) + '</span>' : '') +
          '</div>' +
          (s.vesselName ? '<div class="rnw-trk-stop__vessel">' + escapeHtml(s.vesselName) +
            (s.voyageNumber ? ' · ' + escapeHtml(s.voyageNumber) : '') + '</div>' : '') +
        '</div>' +
        '<div class="rnw-trk-stop__events">' + rows + '</div>' +
      '</li>';
    }).join('');

    var docsHtml = '';
    if (j.documents.length) {
      docsHtml = '<li class="rnw-trk-stop is-doc">' +
        '<div class="rnw-trk-stop__head">' +
          '<div class="rnw-trk-stop__port">' + escapeHtml(t('trk_documents', 'Documents')) + '</div>' +
        '</div>' +
        '<div class="rnw-trk-stop__events">' +
          j.documents.map(function (ev) {
            return '<div class="rnw-trk-ev' + (ev.classifier !== 'ACT' ? ' is-est' : '') + '">' +
              '<span class="rnw-trk-ev__name">' + escapeHtml(trkEventName(ev)) + '</span>' +
              '<span class="rnw-trk-ev__time">' + fmtDate(ev.dateTime, true) + '</span>' +
            '</div>';
          }).join('') +
        '</div>' +
      '</li>';
    }

    var timeline = (docsHtml || stopsHtml)
      ? '<ol class="rnw-trk-timeline">' + docsHtml + stopsHtml + '</ol>'
      : '<div class="rnw-trk-pending">' + escapeHtml(t('trk_pending', 'Tracking started — events will appear soon.')) + '</div>';

    return '<section class="rnw-acc-card rnw-trk">' +
      '<div class="rnw-trk-top">' +
        '<div>' +
          '<div class="rnw-acc-card__label">' + escapeHtml(t('trk_title', 'Container Tracking')) + '</div>' +
          (refs.length ? '<div class="rnw-trk-refs">' + refs.join('') + '</div>' : '') +
        '</div>' +
        badge +
      '</div>' +
      routeHtml +
      etaHtml +
      timeline +
      (trk.lastSyncAt ? '<div class="rnw-trk-updated">' + escapeHtml(t('trk_updated', 'Last updated')) + ': ' +
        fmtDate(trk.lastSyncAt, true) + '</div>' : '') +
    '</section>';
  }

  function renderOrderDetail(o, requests) {
    var detailEl = $('[data-rnw-order-detail]');
    if (!detailEl) return;
    requests = requests || [];
    var p = o.productSnapshot || {};
    var pricing = o.pricing || {};
    var st = effectiveStatusInfo(o, requests);
    var origin = o.origin || {};
    var buyer = o.buyer || {};
    var supplier = o.supplierSnapshot || {};

    var openRequest = requests.find(function (r) {
      return r.status !== 'completed' && r.status !== 'closed' && r.status !== 'cancelled_by_buyer' && r.status !== 'rejected';
    });
    var allowed = allowedActionsForOrderStatus(o.status);
    var canCreateRequest = allowed.length > 0 && !openRequest;

    var certRows = (o.certificates || []).map(function (c) {
      return (
        '<tr><td>' +
          '<div style="font-weight:500">' + escapeHtml(c.name) + ' certificate — ' + c.percent + '%</div>' +
          '<div style="font-size:11.5px;color:var(--rnw-acc-ink-3);margin-top:2px">' + (pricing.kg || 0) + ' kg × $' + Number(c.pricePerKg || 0).toFixed(2) + ' / kg</div>' +
        '</td><td style="text-align:right" class="rnw-acc-mono">$' + Number(c.amount || 0).toFixed(2) + '</td></tr>'
      );
    }).join('');

    var requestsHtml = '';
    if (requests.length > 0) {
      requestsHtml = '<div class="rnw-acc-card" style="margin-bottom:16px">' +
        '<div class="rnw-acc-card__label">Your requests for this order</div>' +
        '<div style="display:flex;flex-direction:column;gap:10px">' +
          requests.map(function (r) {
            var rs = REQUEST_STATUS_LABEL[r.status] || r.status;
            var rstyle = REQUEST_STATUS_STYLE[r.status] || '';
            return '<div style="padding:14px 16px;border:1px solid var(--border_color, #ccc);border-radius:12px;display:flex;align-items:center;gap:12px;flex-wrap:wrap;justify-content:space-between">' +
              '<div style="min-width:0">' +
                '<div style="font-weight:600;font-size:14px">' + escapeHtml(TYPE_LABEL[r.type] || r.type) + ' · ' + escapeHtml(REASON_LABEL[r.reason] || r.reason) + '</div>' +
                '<div style="font-size:12.5px;color:#64748b;margin-top:2px">' + escapeHtml(r.requestNumber) + ' · ' + fmtDate(r.createdAt) + '</div>' +
              '</div>' +
              '<span class="rnw-acc-badge" style="' + rstyle + ';padding:4px 12px">' + escapeHtml(rs) + '</span>' +
            '</div>';
          }).join('') +
        '</div>' +
      '</div>';
    }

    var actionsHtml = '';
    if (canCreateRequest) {
      actionsHtml = '<div style="display:flex;gap:10px;flex-wrap:wrap">';
      if (allowed.indexOf('cancel') >= 0) {
        actionsHtml += '<button type="button" class="rnw-acc-btn rnw-acc-btn--sm" data-rnw-create-request="cancel">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>' +
          (window.rnwT?window.rnwT('account.btn_cancel_order',"Cancel order"):"Cancel order") +
          '</button>';
      }
      if (allowed.indexOf('return') >= 0) {
        actionsHtml += '<button type="button" class="rnw-acc-btn rnw-acc-btn--sm" data-rnw-create-request="return">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 11-3-6.7L21 8"/><polyline points="21 3 21 9 15 9"/></svg>' +
          'Request return' +
          '</button>';
      }
      if (allowed.indexOf('exchange') >= 0) {
        actionsHtml += '<button type="button" class="rnw-acc-btn rnw-acc-btn--sm" data-rnw-create-request="exchange">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 014-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 01-4 4H3"/></svg>' +
          'Request exchange' +
          '</button>';
      }
      actionsHtml += '</div>';
    } else if (openRequest) {
      actionsHtml = '<div style="font-size:13px;color:#64748b;padding:10px 14px;background:#f8fafc;border:1px solid var(--border_color, #ccc);border-radius:10px">' +
        'You have an open request for this order: <strong>' + escapeHtml(openRequest.requestNumber) + '</strong>' +
        '</div>';
    }

    detailEl.innerHTML =
      '<button type="button" class="rnw-acc-back" data-rnw-order-back>' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>' +
        (window.rnwT?window.rnwT('account.btn_all_orders',"All orders"):"All orders") +
      '</button>' +
      '<div class="rnw-acc-section-head" style="margin-bottom:18px">' +
        '<div>' +
          '<div style="font-family:\'JetBrains Mono\',monospace;font-size:18px;font-weight:600;color:var(--rnw-acc-ink-2);margin-bottom:2px">' + escapeHtml(o.orderNumber) + '</div>' +
          '<div class="rnw-acc-h2-sub">' + fmtDate(o.createdAt, true) + '</div>' +
        '</div>' +
        '<span class="rnw-acc-badge" style="' + st.style + ';padding:6px 14px;font-size:12.5px">' + escapeHtml(st.label) + '</span>' +
      '</div>' +
      requestsHtml +
      buildTrackingHtml(o) +
      (actionsHtml ? '<div style="margin-bottom:18px">' + actionsHtml + '</div>' : '') +
      '<div class="rnw-acc-detail-grid">' +
        '<div class="rnw-acc-card">' +
          '<div class="rnw-acc-card__label">Product</div>' +
          '<div class="rnw-acc-product-title">' + escapeHtml(p.titleDisplay || p.title || '—') + '</div>' +
          '<div class="rnw-acc-product-attrs">' +
            '<span><span class="lbl">' + (window.rnwT?window.rnwT('account.label_number','Number'):'Number') + ':</span> <strong>' + escapeHtml(p.number || '—') + '</strong></span>' +
            '<span><span class="lbl">' + (window.rnwT?window.rnwT('account.label_color','Color'):'Color') + ':</span> <strong>' + escapeHtml(p.color || '—') + '</strong></span>' +
            (p.sku ? '<span><span class="lbl">SKU:</span> <strong class="rnw-acc-mono">' + escapeHtml(p.sku) + '</strong></span>' : '') +
            (origin.name ? '<span><span class="lbl">Origin:</span> <strong>' + escapeHtml(origin.flagEmoji || '') + ' ' + escapeHtml(origin.name) + '</strong></span>' : '') +
            '<span><span class="lbl">Supplier:</span> <strong>' + escapeHtml(supplier.displayName || supplier.name || '—') + '</strong></span>' +
          '</div>' +
        '</div>' +
        '<div class="rnw-acc-card">' +
          '<div class="rnw-acc-card__label">Price Breakdown</div>' +
          '<table class="rnw-acc-price-table">' +
            '<tr><td>' +
              '<div style="font-weight:500">Yarn</div>' +
              '<div style="font-size:11.5px;color:var(--rnw-acc-ink-3);margin-top:2px">' + (pricing.kg || 0) + ' kg × $' + Number(pricing.pricePerKg || 0).toFixed(2) + ' / kg</div>' +
            '</td><td style="text-align:right" class="rnw-acc-mono">$' + Number(pricing.yarnAmount || 0).toFixed(2) + '</td></tr>' +
            certRows +
            '<tr class="is-total"><td>Total</td>' +
              '<td style="text-align:right" class="rnw-acc-mono">' + money(pricing.total, pricing.currency) + '</td></tr>' +
          '</table>' +
        '</div>' +
        '<div class="rnw-acc-card">' +
          '<div class="rnw-acc-card__label">Delivery</div>' +
          '<div class="rnw-acc-buyer-name">' + escapeHtml(buyer.name || '—') + '</div>' +
          (buyer.companyName ? '<div class="rnw-acc-buyer-co">' + escapeHtml(buyer.companyName) + '</div>' : '') +
          '<div class="rnw-acc-buyer-contact">' + escapeHtml(buyer.email || '—') + (buyer.phone ? ' · ' + escapeHtml(buyer.phone) : '') + '</div>' +
          (buyer.addressLine ? (
            '<div class="rnw-acc-buyer-addr">' +
              escapeHtml(buyer.addressLine) +
              (buyer.district ? ', ' + escapeHtml(buyer.district) : '') +
              (buyer.city ? '<br>' + escapeHtml(buyer.city) : '') +
              (buyer.postalCode ? ' ' + escapeHtml(buyer.postalCode) : '') +
              (buyer.country ? ', ' + escapeHtml(buyer.country) : '') +
            '</div>'
          ) : '') +
          (buyer.notes ? (
            '<div class="rnw-acc-buyer-note">' +
              '<strong style="display:block;margin-bottom:3px;color:var(--rnw-acc-ink)">Order note:</strong>' + escapeHtml(buyer.notes) +
            '</div>'
          ) : '') +
        '</div>' +
      '</div>';

    var backBtn = $('[data-rnw-order-back]', detailEl);
    if (backBtn) backBtn.addEventListener('click', function () { switchDashboardTab('orders'); });

    $$('[data-rnw-create-request]', detailEl).forEach(function (btn) {
      btn.addEventListener('click', function () {
        openRequestModal(btn.getAttribute('data-rnw-create-request'), o);
      });
    });
  }

  // ============ Request modal ============

  function openRequestModal(type, order) {
    var modal = $('#rnw-request-modal');
    if (!modal) return;
    var typeLabel = TYPE_LABEL[type] || type;

    var typeSpecificHtml = '';
    if (type === 'exchange') {
      typeSpecificHtml = '<div data-rnw-rm-exchange><label class="rnw-acc-field">' +
        '<span>Which variant do you want to exchange for?<span class="req">*</span></span>' +
        '<input type="text" name="desiredVariantText" required placeholder="e.g. NE 20/1 / White">' +
        '<div class="rnw-acc-help">Write a currently available variant. The supplier will verify availability.</div>' +
        '</label></div>';
    } else if (type === 'return') {
      typeSpecificHtml = '<label class="rnw-acc-field">' +
        '<span>Preferred resolution</span>' +
        '<select name="resolutionPreference">' +
          '<option value="">— Let the supplier decide —</option>' +
          '<option value="refund">Refund</option>' +
          '<option value="replacement">Replacement</option>' +
          '<option value="store_credit">Store credit</option>' +
          '<option value="discount">Discount</option>' +
        '</select>' +
        '</label>';
    }

    var affectedKgHtml = (type !== 'cancel')
      ? '<label class="rnw-acc-field">' +
          '<span>Affected quantity (kg) — optional</span>' +
          '<input type="number" name="affectedKg" step="0.1" min="0" placeholder="e.g. 50 (leave blank if entire order)">' +
        '</label>'
      : '';

    var formHtml =
      '<div class="rnw-acc-auth-card" style="max-width:none;padding:0;border:none;box-shadow:none">' +
        '<h2 class="rnw-acc-title" style="margin-bottom:14px">' + typeLabel + ' <em>request</em></h2>' +
        '<p class="rnw-acc-sub">' + escapeHtml((order.productSnapshot && (order.productSnapshot.titleDisplay || order.productSnapshot.title)) || '') + ' · ' + escapeHtml(order.orderNumber) + '</p>' +
        '<div class="rnw-acc-err" data-rnw-rm-err hidden></div>' +
        '<form data-rnw-request-form>' +
          '<input type="hidden" name="orderId" value="' + escapeAttr(order._id || order.id || '') + '">' +
          '<input type="hidden" name="type" value="' + type + '">' +
          '<label class="rnw-acc-field">' +
            '<span>Reason<span class="req">*</span></span>' +
            '<select name="reason" required>' +
              '<option value="">— Select —</option>' +
              (type === 'cancel'
                ? '<option value="changed_mind">Changed my mind</option>' +
                  '<option value="wrong_order">Placed the wrong order</option>' +
                  '<option value="late">Taking too long to deliver</option>' +
                  '<option value="other">Other</option>'
                : '<option value="defective">Defective product</option>' +
                  '<option value="wrong_color_or_number">Wrong color or count</option>' +
                  '<option value="wrong_order">Wrong order placed</option>' +
                  '<option value="late">Late delivery</option>'
              ) +
            '</select>' +
          '</label>' +
          affectedKgHtml +
          typeSpecificHtml +
          '<label class="rnw-acc-field">' +
            '<span>Description (optional)</span>' +
            '<textarea name="customerNote" rows="4" maxlength="2000" placeholder="What you would like to tell the supplier..."></textarea>' +
          '</label>' +
          '<div style="display:flex;gap:10px;margin-top:8px">' +
            '<button type="submit" class="rnw-acc-btn rnw-acc-btn--primary">Send request</button>' +
            '<button type="button" class="rnw-acc-btn" data-rnw-rm-close>Cancel</button>' +
          '</div>' +
        '</form>' +
      '</div>';

    modal.querySelector('[data-rnw-rm-body]').innerHTML = formHtml;
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    bindRequestModal(order);
  }

  function closeRequestModal() {
    var modal = $('#rnw-request-modal');
    if (modal) modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function escapeAttr(s) { return escapeHtml(s); }

  function bindRequestModal(order) {
    var modal = $('#rnw-request-modal');
    if (!modal) return;
    $$('[data-rnw-rm-close]', modal).forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); closeRequestModal(); });
    });
    var form = $('[data-rnw-request-form]', modal);
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var errEl = modal.querySelector('[data-rnw-rm-err]');
      errEl.hidden = true;
      var fd = new FormData(form);
      var body = {
        orderId: fd.get('orderId'),
        type: fd.get('type'),
        reason: fd.get('reason'),
        customerNote: fd.get('customerNote') || ''
      };
      var ak = fd.get('affectedKg');
      if (ak) body.affectedKg = ak;
      if (fd.get('resolutionPreference')) body.resolutionPreference = fd.get('resolutionPreference');
      if (body.type === 'exchange') {
        body.exchangeText = fd.get('desiredVariantText') || '';
        body.customerNote = (body.exchangeText ? 'Desired variant: ' + body.exchangeText + '\n\n' : '') + body.customerNote;
      }
      var btn = form.querySelector('button[type=submit]');
      btn.disabled = true; btn.textContent = (window.rnwT?window.rnwT('common.sending',"Sending..."):"Sending...");
      api('/panel/buyer/api/order-requests', { method: 'POST', body: body }).then(function (res) {
        btn.disabled = false; btn.textContent = (window.rnwT?window.rnwT('account.btn_send_request',"Send request"):"Send request");
        if (!res.ok) {
          errEl.textContent = res.data.error || (window.rnwT?window.rnwT('account.error_request_creation',"Could not create request"):"Could not create request");
          errEl.hidden = false;
          return;
        }
        closeRequestModal();
        openOrderDetail(state.currentOrderId);
      });
    });
  }

  // ---- Addresses ----

  function renderAddresses() {
    var listEl = $('[data-rnw-addr-list]');
    if (!listEl) return;
    if (state.addresses.length === 0) {
      listEl.innerHTML = '<div class="rnw-acc-empty" style="margin-bottom:24px">' +
        '<div class="rnw-acc-empty__icon">' +
          '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>' +
        '</div>' +
        '<div class="rnw-acc-empty__title">No addresses yet</div>' +
        '<div class="rnw-acc-empty__desc">Add your first address below; it will autofill on new orders.</div>' +
      '</div>';
      return;
    }
    listEl.innerHTML = '<div class="rnw-acc-addr-grid">' + state.addresses.map(function (a, idx) {
      return (
        '<div class="rnw-acc-addr-card' + (a.isDefault ? ' is-default' : '') + '">' +
          (a.isDefault ? '<div class="rnw-acc-addr-flag">' +
            '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' +
            'Default</div>' : '') +
          (a.label ? '<div class="rnw-acc-addr-label">' + escapeHtml(a.label) + '</div>' : '') +
          '<div class="rnw-acc-addr-text">' +
            escapeHtml(a.addressLine || '') +
            (a.district ? ', ' + escapeHtml(a.district) : '') +
            (a.city ? '<br>' + escapeHtml(a.city) : '') +
            (a.postalCode ? ' ' + escapeHtml(a.postalCode) : '') +
            (a.country ? ', ' + escapeHtml(a.country) : '') +
          '</div>' +
          '<div class="rnw-acc-addr-actions">' +
            (!a.isDefault ? '<button type="button" class="rnw-acc-linkbtn rnw-acc-linkbtn--muted" data-rnw-addr-default="' + idx + '">Make default</button>' : '') +
            '<button type="button" class="rnw-acc-linkbtn rnw-acc-linkbtn--danger" data-rnw-addr-delete="' + idx + '">Delete</button>' +
          '</div>' +
        '</div>'
      );
    }).join('') + '</div>';

    $$('[data-rnw-addr-default]', listEl).forEach(function (b) {
      b.addEventListener('click', function () { setDefaultAddress(parseInt(b.getAttribute('data-rnw-addr-default'), 10)); });
    });
    $$('[data-rnw-addr-delete]', listEl).forEach(function (b) {
      b.addEventListener('click', function () {
        if (!confirm((window.rnwT?window.rnwT('account.confirm_delete_address',"Delete this address?"):"Delete this address?"))) return;
        deleteAddress(parseInt(b.getAttribute('data-rnw-addr-delete'), 10));
      });
    });
  }

  function submitAddressForm() {
    var form = $('[data-rnw-addr-form]');
    var fd = new FormData(form);
    var body = {
      label: fd.get('label') || '',
      addressLine: fd.get('addressLine') || '',
      city: fd.get('city') || '',
      district: fd.get('district') || '',
      postalCode: fd.get('postalCode') || '',
      country: fd.get('country') || 'Türkiye',
      isDefault: !!fd.get('isDefault')
    };
    var btn = form.querySelector('button[type=submit]');
    btn.disabled = true; btn.textContent = 'Adding...';
    api('/panel/buyer/api/addresses', { method: 'POST', body: body }).then(function (res) {
      btn.disabled = false; btn.textContent = (window.rnwT?window.rnwT('account.btn_save_address',"Save address"):"Save address");
      if (!res.ok) {
        alert(res.data.error || 'Could not add address');
        return;
      }
      state.addresses = res.data.addresses || [];
      state.customer.addresses = state.addresses;
      form.reset();
      $('[data-rnw-addr-country]').value = 'Türkiye';
      renderAddresses();
    });
  }

  function setDefaultAddress(idx) {
    api('/panel/buyer/api/addresses/' + idx + '/default', { method: 'POST' }).then(function (res) {
      if (res.ok) {
        state.addresses = res.data.addresses || [];
        state.customer.addresses = state.addresses;
        renderAddresses();
      }
    });
  }

  function deleteAddress(idx) {
    api('/panel/buyer/api/addresses/' + idx + '/delete', { method: 'POST' }).then(function (res) {
      if (res.ok) {
        state.addresses = res.data.addresses || [];
        state.customer.addresses = state.addresses;
        renderAddresses();
      }
    });
  }

  // ---- Settings ----

  function renderSettings() {
    var form = $('[data-rnw-settings-form]');
    if (!form) return;
    var c = state.customer;
    form.querySelector('input[name=email]').value = c.email || '';
    form.querySelector('input[name=name]').value = c.name || '';
    form.querySelector('input[name=companyName]').value = c.companyName || '';
    form.querySelector('input[name=taxNumber]').value = c.taxNumber || '';
    form.querySelector('input[name=phone]').value = c.phone || '';
    var flashEl = $('[data-rnw-settings-flash]');
    if (flashEl) flashEl.hidden = true;
    var loginEl = $('[data-rnw-last-login]');
    if (loginEl) loginEl.textContent = c.lastLoginAt ? fmtDate(c.lastLoginAt, true) : 'First session';
  }

  function submitSettingsForm() {
    var form = $('[data-rnw-settings-form]');
    var fd = new FormData(form);
    var body = {
      name: fd.get('name') || '',
      companyName: fd.get('companyName') || '',
      taxNumber: fd.get('taxNumber') || '',
      phone: fd.get('phone') || ''
    };
    var btn = form.querySelector('button[type=submit]');
    btn.disabled = true; btn.textContent = (window.rnwT?window.rnwT('common.saving',"Saving..."):"Saving...");
    api('/panel/buyer/api/settings', { method: 'POST', body: body }).then(function (res) {
      btn.disabled = false; btn.textContent = 'Save';
      if (!res.ok) { alert(res.data.error || 'Could not save'); return; }
      state.customer = res.data.customer;
      renderUserCard();
      var flashEl = $('[data-rnw-settings-flash]');
      if (flashEl) { flashEl.hidden = false; setTimeout(function () { flashEl.hidden = true; }, 3500); }
    });
  }

  // ============================================================
  // Negotiations
  // ============================================================

  var NG_STATUS_LABEL = {
    get open()                  { return _t('ng_status.open',      'Open'); },
    get accepted()              { return _t('ng_status.accepted',  'Accepted'); },
    get agreed()                { return _t('ng_status.accepted',  'Agreed'); },
    get fulfilled()             { return _t('ng_status.fulfilled', 'Order placed'); },
    get expired()               { return _t('ng_status.expired',   'Expired'); },
    get rejected_by_supplier()  { return _t('ng_status.rejected',  'Rejected by supplier'); },
    get rejected_by_buyer()     { return _t('ng_status.rejected',  'Rejected by you'); },
    get cancelled_by_buyer()    { return _t('ng_status.cancelled', 'Cancelled by you'); }
  };
  var NG_STATUS_STYLE = {
    open: 'background:#dbeafe;color:#1e40af',
    agreed: 'background:#d1fae5;color:#065f46',
    fulfilled: 'background:#dcfce7;color:#14532d',
    rejected_by_supplier: 'background:#fee2e2;color:#991b1b',
    rejected_by_buyer: 'background:#fee2e2;color:#991b1b',
    cancelled_by_buyer: 'background:#f1f5f9;color:#475569'
  };

  // ---- Sample Requests ----

  var SMP_STATUS_STYLE = {
    requested: 'background:#fef3c7;color:#92400e',
    priced: 'background:#dbeafe;color:#1e40af',
    paid_declared: 'background:#e0e7ff;color:#3730a3',
    shipped: 'background:#dcfce7;color:#166534',
    completed: 'background:#dcfce7;color:#166534',
    rejected: 'background:#fee2e2;color:#991b1b',
    cancelled: 'background:#f1f5f9;color:#475569'
  };

  function smpStatusLabel(sr) {
    var t = function (k, fb) { return window.rnwT ? window.rnwT('account.' + k, fb) : fb; };
    switch (sr.status) {
      case 'requested': return t('sample_st_requested', 'Awaiting supplier');
      case 'priced': return sr.priceTRY > 0 ? t('sample_st_priced', 'Priced — pay by transfer') : t('sample_st_priced_free', 'Approved — free');
      case 'paid_declared': return t('sample_st_paid', 'Payment declared');
      case 'shipped': return t('sample_st_shipped', 'Shipped');
      case 'completed': return t('sample_st_completed', 'Completed');
      case 'rejected': return t('sample_st_rejected', 'Rejected');
      case 'cancelled': return t('sample_st_cancelled', 'Cancelled');
      default: return sr.status;
    }
  }

  function loadSamples() {
    var listEl = $('[data-rnw-samples-list]');
    if (!listEl) return;
    listEl.innerHTML = '<div class="rnw-acc-loading"><div class="rnw-acc-loading__spin"></div><div>' + (window.rnwT?window.rnwT('common.loading',"Loading"):"Loading") + '</div></div>';
    api('/panel/buyer/api/sample-requests').then(function (res) {
      if (!res.ok) {
        listEl.innerHTML = '<div class="rnw-acc-empty"><div class="rnw-acc-empty__title">Could not load</div></div>';
        return;
      }
      state.sampleRequests = res.data.sampleRequests || [];
      renderSamplesList();
    });
  }

  function renderSamplesList() {
    var listEl = $('[data-rnw-samples-list]');
    if (!listEl) return;
    var t = function (k, fb) { return window.rnwT ? window.rnwT('account.' + k, fb) : fb; };
    if (!state.sampleRequests || state.sampleRequests.length === 0) {
      listEl.innerHTML = '<div class="rnw-acc-empty">' +
        '<div class="rnw-acc-empty__title">' + escapeHtml(t('sample_empty', 'No sample requests yet.')) + '</div>' +
        '</div>';
      return;
    }
    var cards = state.sampleRequests.map(function (sr) {
      var p = sr.product || {};
      var stStyle = SMP_STATUS_STYLE[sr.status] || '';
      var payable = sr.status === 'priced' && sr.priceTRY > 0;

      var bankHtml = '';
      if (payable && sr.bankInfo) {
        var b = sr.bankInfo;
        bankHtml =
          '<div class="rnw-acc-smp-bank">' +
            '<div class="rnw-acc-smp-bank__title">' + escapeHtml(t('sample_bank_title', 'Bank transfer details')) + '</div>' +
            (b.bankName ? '<div><span class="lbl">Banka:</span> <strong>' + escapeHtml(b.bankName) + (b.branch ? ' / ' + escapeHtml(b.branch) : '') + '</strong></div>' : '') +
            (b.accountHolder ? '<div><span class="lbl">Alıcı:</span> <strong>' + escapeHtml(b.accountHolder) + '</strong></div>' : '') +
            '<div><span class="lbl">IBAN:</span> <strong style="user-select:all">' + escapeHtml(b.iban) + '</strong></div>' +
            '<div><span class="lbl">' + escapeHtml(t('sample_fee', 'Sample fee')) + ':</span> <strong>' + Number(sr.priceTRY).toLocaleString('tr-TR') + ' TL</strong></div>' +
            '<div class="lbl" style="margin-top:4px">' + escapeHtml(t('sample_ref_note', 'Reference')) + ': <strong>' + escapeHtml(sr.requestNumber) + '</strong></div>' +
          '</div>';
      }

      var actions = '';
      if (payable) {
        actions += '<button type="button" class="rnw-acc-btn rnw-acc-btn--primary" data-rnw-smp-paid="' + escapeHtml(sr.id) + '">' + escapeHtml(t('sample_mark_paid', 'I made the transfer')) + '</button>';
      }
      if (sr.status === 'requested' || sr.status === 'priced') {
        actions += '<button type="button" class="rnw-acc-btn" data-rnw-smp-cancel="' + escapeHtml(sr.id) + '">' + escapeHtml(t('sample_cancel', 'Cancel request')) + '</button>';
      }

      var shipHtml = '';
      if (sr.status === 'shipped' || sr.status === 'completed') {
        shipHtml = '<div class="rnw-acc-order-meta" style="margin-top:4px">' +
          '<span><strong>' + escapeHtml(t('sample_tracking', 'Tracking')) + ':</strong> ' + escapeHtml(sr.carrierName || '—') + (sr.trackingNumber ? ' / ' + escapeHtml(sr.trackingNumber) : '') + '</span>' +
          '</div>';
      }

      return (
        '<div class="rnw-acc-order-card" style="cursor:default">' +
          '<div class="rnw-acc-order-card__left">' +
            '<div class="rnw-acc-order-card__top">' +
              '<span class="rnw-acc-order-no">' + escapeHtml(sr.requestNumber) + '</span>' +
              '<span class="rnw-acc-order-date">' + fmtDate(sr.createdAt) + '</span>' +
            '</div>' +
            '<div class="rnw-acc-order-title">' + escapeHtml(p.title || '—') + '</div>' +
            '<div class="rnw-acc-order-meta">' +
              '<span><strong>' + (window.rnwT?window.rnwT('account.label_number','Number'):'Number') + ':</strong> ' + escapeHtml(p.number || '—') + '</span>' +
              '<span><strong>' + (window.rnwT?window.rnwT('account.label_color','Color'):'Color') + ':</strong> ' + escapeHtml(p.color || '—') + '</span>' +
              (sr.supplierName ? '<span><strong>' + escapeHtml(t('sample_supplier', 'Supplier')) + ':</strong> ' + escapeHtml(sr.supplierName) + '</span>' : '') +
            '</div>' +
            (sr.supplierNote ? '<div class="rnw-acc-order-meta" style="margin-top:4px"><span>' + escapeHtml(sr.supplierNote) + '</span></div>' : '') +
            (sr.rejectedReason ? '<div class="rnw-acc-order-meta" style="margin-top:4px;color:#991b1b"><span>' + escapeHtml(sr.rejectedReason) + '</span></div>' : '') +
            shipHtml +
            bankHtml +
            (actions ? '<div class="rnw-acc-smp-actions">' + actions + '</div>' : '') +
          '</div>' +
          '<div class="rnw-acc-order-card__right">' +
            '<span class="rnw-acc-badge" style="' + (SMP_STATUS_STYLE[sr.status] || '') + '">' + escapeHtml(smpStatusLabel(sr)) + '</span>' +
            (sr.status === 'priced' && sr.priceTRY > 0 ? '<div class="rnw-acc-order-amount">' + Number(sr.priceTRY).toLocaleString('tr-TR') + ' TL</div>' : '') +
          '</div>' +
        '</div>'
      );
    }).join('');
    listEl.innerHTML = '<div class="rnw-acc-order-list">' + cards + '</div>';

    $$('[data-rnw-smp-paid]', listEl).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var t2 = function (k, fb) { return window.rnwT ? window.rnwT('account.' + k, fb) : fb; };
        if (!confirm(t2('sample_paid_confirm', 'Confirm that you made the bank transfer?'))) return;
        btn.disabled = true;
        api('/panel/buyer/api/sample-requests/' + btn.getAttribute('data-rnw-smp-paid') + '/mark-paid', { method: 'POST', body: {} }).then(function (res) {
          if (res.ok) loadSamples();
          else { btn.disabled = false; alert(res.data.error || 'Error'); }
        });
      });
    });
    $$('[data-rnw-smp-cancel]', listEl).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var t2 = function (k, fb) { return window.rnwT ? window.rnwT('account.' + k, fb) : fb; };
        if (!confirm(t2('sample_cancel_confirm', 'Cancel this sample request?'))) return;
        btn.disabled = true;
        api('/panel/buyer/api/sample-requests/' + btn.getAttribute('data-rnw-smp-cancel') + '/cancel', { method: 'POST', body: {} }).then(function (res) {
          if (res.ok) loadSamples();
          else { btn.disabled = false; alert(res.data.error || 'Error'); }
        });
      });
    });
  }

  // ---- RFQ / Quote Requests ----

  var RFQ_STATUS_STYLE = {
    open: 'background:#dcfce7;color:#166534',
    closed: 'background:#f1f5f9;color:#475569',
    cancelled: 'background:#fee2e2;color:#991b1b'
  };

  function loadRfqs() {
    var listEl = $('[data-rnw-rfqs-list]');
    if (!listEl) return;
    listEl.innerHTML = '<div class="rnw-acc-loading"><div class="rnw-acc-loading__spin"></div><div>' + (window.rnwT?window.rnwT('common.loading',"Loading"):"Loading") + '</div></div>';
    api('/panel/buyer/api/rfqs').then(function (res) {
      if (!res.ok) {
        listEl.innerHTML = '<div class="rnw-acc-empty"><div class="rnw-acc-empty__title">Could not load</div></div>';
        return;
      }
      state.rfqs = res.data.rfqs || [];
      renderRfqsList();
    });
  }

  function renderRfqsList() {
    var listEl = $('[data-rnw-rfqs-list]');
    if (!listEl) return;
    var t = function (k, fb) { return window.rnwT ? window.rnwT('account.' + k, fb) : fb; };
    if (!state.rfqs || state.rfqs.length === 0) {
      listEl.innerHTML = '<div class="rnw-acc-empty">' +
        '<div class="rnw-acc-empty__title">' + escapeHtml(t('rfq_empty', 'No quote requests yet.')) + '</div>' +
        '</div>';
      return;
    }
    var stLabel = function (s) {
      if (s === 'open') return t('rfq_st_open', 'Open');
      if (s === 'closed') return t('rfq_st_closed', 'Closed');
      if (s === 'cancelled') return t('rfq_st_cancelled', 'Cancelled');
      return s;
    };
    var cards = state.rfqs.map(function (r) {
      var quotesHtml;
      if (r.quotes && r.quotes.length > 0) {
        quotesHtml =
          '<div class="rnw-acc-rfq-quotes">' +
            '<div class="rnw-acc-rfq-quotes__title">' + escapeHtml(t('rfq_quotes_title', 'Quotes')) + ' (' + r.quotes.length + ')</div>' +
            r.quotes.map(function (q) {
              return '<div class="rnw-acc-rfq-quote">' +
                '<strong>' + escapeHtml(q.supplierName || '—') + '</strong>' +
                ' · <strong>$' + Number(q.pricePerKg).toFixed(2) + '/kg</strong>' +
                (q.leadTimeDays ? ' · ' + escapeHtml(t('rfq_lead', 'Lead time')) + ': ' + q.leadTimeDays + ' ' + escapeHtml(t('rfq_days', 'days')) : '') +
                (q.note ? '<div class="rnw-acc-rfq-quote__note">' + escapeHtml(q.note) + '</div>' : '') +
                '</div>';
            }).join('') +
          '</div>';
      } else {
        quotesHtml = '<div class="rnw-acc-rfq-quotes"><div class="rnw-acc-rfq-quotes__empty">' + escapeHtml(t('rfq_no_quotes', 'No quotes yet — suppliers have been notified.')) + '</div></div>';
      }
      var actions = '';
      if (r.status === 'open') {
        actions = '<div class="rnw-acc-smp-actions"><button type="button" class="rnw-acc-btn" data-rnw-rfq-close="' + escapeHtml(r.id) + '">' + escapeHtml(t('rfq_close_btn', 'Close request')) + '</button></div>';
      }
      var p = r.product || {};
      var variantInfo = (p.number || p.color) ? ((p.number || '—') + ' / ' + (p.color || '—')) : '';
      return (
        '<div class="rnw-acc-order-card" style="cursor:default">' +
          '<div class="rnw-acc-order-card__left">' +
            '<div class="rnw-acc-order-card__top">' +
              '<span class="rnw-acc-order-no">' + escapeHtml(r.rfqNumber) + '</span>' +
              '<span class="rnw-acc-order-date">' + fmtDate(r.createdAt) + '</span>' +
            '</div>' +
            '<div class="rnw-acc-order-title">' + escapeHtml(r.yarnName) + '</div>' +
            '<div class="rnw-acc-order-meta">' +
              (variantInfo ? '<span><strong>' + (window.rnwT?window.rnwT('account.label_number','Number'):'Number') + '/' + (window.rnwT?window.rnwT('account.label_color','Color'):'Color') + ':</strong> ' + escapeHtml(variantInfo) + '</span>' : '') +
              '<span><strong>' + (window.rnwT?window.rnwT('account.label_quantity','Quantity'):'Quantity') + ':</strong> ' + (r.kg || 0) + ' kg</span>' +
              (r.targetPricePerKg != null ? '<span><strong>' + escapeHtml(t('rfq_target', 'Target')) + ':</strong> $' + Number(r.targetPricePerKg).toFixed(2) + '/kg</span>' : '') +
              (r.leadTimeDays != null ? '<span><strong>' + escapeHtml(t('rfq_lead', 'Lead time')) + ':</strong> ' + r.leadTimeDays + ' ' + escapeHtml(t('rfq_days', 'days')) + '</span>' : '') +
            '</div>' +
            quotesHtml +
            actions +
          '</div>' +
          '<div class="rnw-acc-order-card__right">' +
            '<span class="rnw-acc-badge" style="' + (RFQ_STATUS_STYLE[r.status] || '') + '">' + escapeHtml(stLabel(r.status)) + '</span>' +
          '</div>' +
        '</div>'
      );
    }).join('');
    listEl.innerHTML = '<div class="rnw-acc-order-list">' + cards + '</div>';

    $$('[data-rnw-rfq-close]', listEl).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var t2 = function (k, fb) { return window.rnwT ? window.rnwT('account.' + k, fb) : fb; };
        if (!confirm(t2('rfq_close_confirm', 'Close this request? Suppliers can no longer quote.'))) return;
        btn.disabled = true;
        api('/panel/buyer/api/rfqs/' + btn.getAttribute('data-rnw-rfq-close') + '/close', { method: 'POST', body: {} }).then(function (res) {
          if (res.ok) loadRfqs();
          else { btn.disabled = false; alert(res.data.error || 'Error'); }
        });
      });
    });
  }

  function loadNegotiations() {
    var listEl = $('[data-rnw-negotiations-list]');
    if (!listEl) return;
    listEl.innerHTML = '<div class="rnw-acc-loading"><div class="rnw-acc-loading__spin"></div><div>' + (window.rnwT?window.rnwT('common.loading',"Loading"):"Loading") + '</div></div>';
    api('/panel/buyer/api/negotiations').then(function (res) {
      if (!res.ok) {
        listEl.innerHTML = '<div class="rnw-acc-empty"><div class="rnw-acc-empty__title">Could not load</div></div>';
        return;
      }
      state.negotiations = res.data.negotiations || [];
      renderNegotiationsList();
    });
  }

  function renderNegotiationsList() {
    var listEl = $('[data-rnw-negotiations-list]');
    if (!listEl) return;
    if (!state.negotiations || state.negotiations.length === 0) {
      listEl.innerHTML = '<div class="rnw-acc-empty">' +
        '<div class="rnw-acc-empty__title">No negotiations yet</div>' +
        '<div class="rnw-acc-empty__desc">Start a counter offer from any product page to negotiate price with the supplier.</div>' +
        '</div>';
      return;
    }
    var cards = state.negotiations.map(function (n) {
      var st = NG_STATUS_LABEL[n.status] || n.status;
      var stStyle = NG_STATUS_STYLE[n.status] || '';
      var awaitingYou = n.awaitingFrom === 'buyer';
      var p = n.productSnapshot || {};
      return (
        '<div class="rnw-acc-order-card" data-rnw-neg-id="' + escapeHtml(n.id) + '" role="button" tabindex="0">' +
          '<div class="rnw-acc-order-card__left">' +
            '<div class="rnw-acc-order-card__top">' +
              '<span class="rnw-acc-order-no">' + escapeHtml(n.negotiationNumber) + '</span>' +
              '<span class="rnw-acc-order-date">' + fmtDate(n.updatedAt) + '</span>' +
            '</div>' +
            '<div class="rnw-acc-order-title">' + escapeHtml(p.titleDisplay || p.title || '—') + '</div>' +
            '<div class="rnw-acc-order-meta">' +
              '<span><strong>' + (window.rnwT?window.rnwT('account.label_quantity','Quantity'):'Quantity') + ':</strong> ' + (n.kg || 0) + ' kg</span>' +
              '<span><strong>List:</strong> $' + Number(n.initialPricePerKg || 0).toFixed(2) + '/kg</span>' +
              '<span><strong>Latest:</strong> $' + Number(n.latestPrice || 0).toFixed(2) + '/kg</span>' +
            '</div>' +
            (awaitingYou ? '<div style="margin-top:4px; font-size:11.5px; color:#1e40af; font-weight:600;">↩ Waiting for your reply</div>' : '') +
          '</div>' +
          '<div class="rnw-acc-order-card__right">' +
            '<span class="rnw-acc-badge" style="' + stStyle + '">' + escapeHtml(st) + '</span>' +
            (n.agreedPricePerKg ? '<div class="rnw-acc-order-amount">$' + Number(n.agreedPricePerKg * n.kg).toFixed(2) + '</div>' : '') +
          '</div>' +
        '</div>'
      );
    }).join('');
    listEl.innerHTML = '<div class="rnw-acc-order-list">' + cards + '</div>';
    $$('[data-rnw-neg-id]', listEl).forEach(function (card) {
      var open = function () { openNegotiationDetail(card.getAttribute('data-rnw-neg-id')); };
      card.addEventListener('click', open);
      card.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
    });
  }

  function openNegotiationDetail(id) {
    state.currentNegotiationId = id;
    switchDashboardTab('negotiation-detail');
    var detailEl = $('[data-rnw-negotiation-detail]');
    if (!detailEl) return;
    detailEl.innerHTML = '<div class="rnw-acc-loading"><div class="rnw-acc-loading__spin"></div><div>' + (window.rnwT?window.rnwT('common.loading',"Loading"):"Loading") + '</div></div>';
    api('/panel/buyer/api/negotiations/' + id).then(function (res) {
      if (!res.ok) {
        detailEl.innerHTML = '<div class="rnw-acc-err">Negotiation not found</div>';
        return;
      }
      renderNegotiationDetail(res.data.negotiation);
    });
  }

  function renderNegotiationDetail(n) {
    state.currentNegotiation = n;
    var detailEl = $('[data-rnw-negotiation-detail]');
    if (!detailEl) return;
    var p = n.productSnapshot || {};
    var v = n.variantSnapshot || {};
    var o = n.originSnapshot || {};
    var stLabel = NG_STATUS_LABEL[n.status] || n.status;
    var stStyle = NG_STATUS_STYLE[n.status] || '';
    var awaitingYou = n.awaitingFrom === 'buyer';

    var roundsHtml = (n.rounds || []).map(function (r, idx) {
      var isBuyer = r.offeredByRole === 'buyer';
      var roleLabel = idx === 0 ? (isBuyer ? 'Your initial offer' : 'Supplier initial offer') : (isBuyer ? 'Your counter' : 'Supplier counter');
      var certsHtml = '';
      // Total ASIL — snapshot'taki değer. Yarn $/kg detayını GÖSTERMİYORUZ (precision drift'i önler)
      var certsTotal = Number(r.certsTotal || 0);
      var totalAmt = Number(r.totalAmount || (Number(r.yarnTotal || 0) + certsTotal));
      var certBadges = '';
      if (r.certificates && r.certificates.length) {
        certBadges = '<div style="margin-top:8px;">' +
          r.certificates.map(function (c) {
            return '<span style="display:inline-block; padding:3px 9px; margin:2px 4px 0 0; background:#fff; border:1px solid #e2e8f0; border-radius:999px; font-size:11.5px;">' +
              escapeHtml(c.name) + ' ' + c.percent + '%' +
            '</span>';
          }).join('') +
        '</div>';
      }
      return (
        '<div style="display:flex; gap:12px; align-items:flex-start; ' + (isBuyer ? '' : 'flex-direction:row-reverse;') + '">' +
          '<div style="flex-shrink:0; width:36px; height:36px; border-radius:50%; background:' + (isBuyer ? '#dbeafe' : '#d1fae5') + '; color:' + (isBuyer ? '#1e40af' : '#065f46') + '; font-weight:700; font-size:12px; display:flex; align-items:center; justify-content:center;">' +
            (isBuyer ? 'You' : 'S') +
          '</div>' +
          '<div style="flex:1; padding:14px 16px; border-radius:10px; background:' + (isBuyer ? '#eff6ff' : '#ecfdf5') + '; border:1px solid ' + (isBuyer ? '#bfdbfe' : '#a7f3d0') + ';">' +
            '<div style="display:flex; justify-content:space-between; gap:10px; font-size:12px; color:#64748b; margin-bottom:8px;">' +
              '<strong>' + escapeHtml(r.offeredByName || (isBuyer ? 'You' : 'Supplier')) + ' · ' + escapeHtml(roleLabel) + '</strong>' +
              '<span>' + fmtDate(r.createdAt, true) + '</span>' +
            '</div>' +
            '<div style="font-size:22px; font-weight:700; color:#0f172a; line-height:1.2;">$' + totalAmt.toFixed(2) + ' <span style="font-size:12px; font-weight:500; color:#64748b;">total</span></div>' +
            (certsTotal > 0
              ? '<div style="margin-top:6px; font-size:12px; color:#64748b;">includes certificates: $' + certsTotal.toFixed(2) + '</div>'
              : '<div style="margin-top:6px; font-size:12px; color:#9ca3af;">no certificates</div>') +
            certBadges +
            (r.message ? '<div style="margin-top:10px; padding:8px 10px; background:#fff; border-radius:6px; font-size:13px; color:#1f2937; white-space:pre-wrap; border:1px solid ' + (isBuyer ? '#dbeafe' : '#d1fae5') + ';">' + escapeHtml(r.message) + '</div>' : '') +
          '</div>' +
        '</div>'
      );
    }).join('');

    // Counter form için cert picker — allowedCertificates'tan
    var allowedCerts = n.allowedCertificates || [];
    var lastRound = (n.rounds || [])[n.rounds.length - 1] || {};
    var currentCerts = {};
    (lastRound.certificates || []).forEach(function (c) { currentCerts[String(c.certificateId)] = c.percent; });
    var certPickerHtml = allowedCerts.length ? (
      '<div style="margin:10px 0; padding:10px; background:#f8fafc; border-radius:6px; font-size:12px;">' +
        '<div style="font-weight:600; margin-bottom:6px; color:#475569;">Certificates for this counter (optional — inherits last round if unchanged)</div>' +
        allowedCerts.map(function (c) {
          var curPct = currentCerts[String(c.certificateId)] || 0;
          var opts = '<option value="0"' + (curPct === 0 ? ' selected' : '') + '>0% (none)</option>';
          (c.tiers || []).forEach(function (t) {
            opts += '<option value="' + t.percent + '"' + (curPct === t.percent ? ' selected' : '') + '>' + t.percent + '% (+$' + Number(t.pricePerKg).toFixed(2) + '/kg)</option>';
          });
          return '<label style="display:flex; gap:8px; align-items:center; margin-bottom:4px;">' +
            '<span style="flex:1; font-size:12px;">' + escapeHtml(c.name) + '</span>' +
            '<select data-rnw-neg-cert="' + escapeHtml(String(c.certificateId)) + '" style="font-size:12px; padding:3px 6px;">' + opts + '</select>' +
          '</label>';
        }).join('') +
      '</div>'
    ) : '';

    var actionsHtml = '';
    var lastSupplierTotal = (lastRound && lastRound.totalAmount) || (n.latestPrice * n.kg) || 0;
    if (n.status === 'open' && awaitingYou) {
      actionsHtml =
        '<div class="rnw-acc-auth-card" style="max-width:none; padding:20px; margin-top:16px;">' +
          '<h3 class="rnw-acc-title" style="margin-bottom:12px;">Your reply</h3>' +
          '<div class="rnw-acc-err" data-rnw-neg-err hidden></div>' +
          '<button type="button" class="rnw-acc-btn rnw-acc-btn--primary rnw-acc-btn--full" data-rnw-neg-action="accept" style="margin-bottom:10px; background:#065f46;">' +
            '✓ Accept supplier offer ($' + Number(lastSupplierTotal).toFixed(2) + ' total)' +
          '</button>' +
          '<div style="padding:14px; border:1px solid var(--border_color, #ddd); border-radius:8px; margin-bottom:10px;">' +
            '<label class="rnw-acc-field"><span>Your counter total ($) — incl. selected certificates</span>' +
              '<input type="number" step="0.01" min="0" data-rnw-neg-counter-total placeholder="e.g. ' + Number(lastSupplierTotal * 0.95).toFixed(2) + '">' +
            '</label>' +
            '<div data-rnw-neg-counter-breakdown style="font-size:12px; color:#475569; margin-bottom:8px;"></div>' +
            certPickerHtml +
            '<label class="rnw-acc-field"><span>Message — explain certificate/quantity preferences (optional)</span>' +
              '<textarea rows="3" maxlength="2000" data-rnw-neg-counter-msg placeholder="e.g. Could you offer the same product with GOTS certificate instead?"></textarea>' +
            '</label>' +
            '<button type="button" class="rnw-acc-btn" data-rnw-neg-action="counter" style="width:100%;">Send counter offer</button>' +
          '</div>' +
          '<button type="button" class="rnw-acc-btn" data-rnw-neg-action="reject" style="width:100%; background:#fee2e2; color:#991b1b;">✕ Decline</button>' +
        '</div>';
    } else if (n.status === 'open' && !awaitingYou) {
      actionsHtml = '<div style="margin-top:16px; padding:14px; background:#fef9c3; border:1px solid #fde68a; color:#854d0e; border-radius:8px;">Waiting for the supplier to respond.</div>';
    } else if (n.status === 'agreed') {
      actionsHtml =
        '<div style="margin-top:16px; padding:18px; background:#d1fae5; border:1px solid #6ee7b7; border-radius:8px;">' +
          '<div style="font-weight:600; color:#065f46; font-size:14px; margin-bottom:6px;">✓ Agreed — $' + Number(n.agreedPricePerKg).toFixed(2) + '/kg × ' + n.kg + ' kg = $' + Number(n.agreedPricePerKg * n.kg).toFixed(2) + '</div>' +
          '<p style="font-size:13px; color:#065f46; margin-bottom:6px;">' + escapeHtml(isTurkish() ? 'Siparişi oluşturun; ödemeyi tedarikçiye havale/EFT ile yaparsınız. Banka bilgileri "Siparişlerim" sekmesinde görünür.' : 'Place the order and pay the supplier by bank transfer. The bank details will appear under "My Orders".') + '</p>' +
          '<p style="font-size:12px; color:#065f46; margin-bottom:12px;">' + escapeHtml(isTurkish() ? 'Sevkiyat, ödemeden sonra tedarikçiyle planlanır. Kendi kargo firmanız varsa bunu tedarikçiye iletin.' : 'Shipping will be arranged with the supplier after payment. If you have your own carrier, let the supplier know.') + '</p>' +
          '<button type="button" class="rnw-acc-btn rnw-acc-btn--primary" data-rnw-neg-action="checkout" style="background:#065f46;">' + escapeHtml(isTurkish() ? 'Siparişi oluştur →' : 'Place order →') + '</button>' +
        '</div>';
    } else if (n.status === 'fulfilled') {
      actionsHtml = '<div style="margin-top:16px; padding:14px; background:#dcfce7; color:#14532d; border-radius:8px;">Order has been placed. Check the "My Orders" tab.</div>';
    } else {
      actionsHtml = '<div style="margin-top:16px; padding:14px; background:#f1f5f9; color:#475569; border-radius:8px;">Negotiation closed: ' + escapeHtml(n.closedReason || stLabel) + '</div>';
    }

    detailEl.innerHTML =
      '<button type="button" class="rnw-acc-back" data-rnw-neg-back>' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>' +
        'All negotiations' +
      '</button>' +
      '<div class="rnw-acc-section-head" style="margin-bottom:18px;">' +
        '<div>' +
          '<div style="font-family:\'JetBrains Mono\',monospace; font-size:18px; font-weight:600; margin-bottom:2px;">' + escapeHtml(n.negotiationNumber) + '</div>' +
          '<div class="rnw-acc-h2-sub">' + escapeHtml(p.title || '') + ' · ' + escapeHtml(v.number || '') + ' / ' + escapeHtml(v.color || '') + ' · ' + escapeHtml((o.flagEmoji || '') + ' ' + (o.name || '')) + '</div>' +
        '</div>' +
        '<span class="rnw-acc-badge" style="' + stStyle + '; padding:6px 14px; font-size:12.5px;">' + escapeHtml(stLabel) + '</span>' +
      '</div>' +
      '<div class="rnw-acc-card" style="padding:18px; margin-bottom:16px;">' +
        '<div class="rnw-acc-card__label">Summary</div>' +
        '<div style="display:flex; gap:18px; flex-wrap:wrap; font-size:14px;">' +
          '<span><strong>' + (window.rnwT?window.rnwT('account.label_quantity','Quantity'):'Quantity') + ':</strong> ' + n.kg + ' kg</span>' +
          '<span><strong>List price:</strong> $' + Number(n.initialPricePerKg).toFixed(2) + '/kg</span>' +
          '<span><strong>Latest offer:</strong> $' + Number(n.latestPrice).toFixed(2) + '/kg</span>' +
        '</div>' +
      '</div>' +
      '<div class="rnw-acc-card" style="padding:18px; margin-bottom:16px;">' +
        '<div class="rnw-acc-card__label">History</div>' +
        '<div style="display:flex; flex-direction:column; gap:10px;">' + roundsHtml + '</div>' +
      '</div>' +
      actionsHtml;

    var backBtn = $('[data-rnw-neg-back]', detailEl);
    if (backBtn) backBtn.addEventListener('click', function () { switchDashboardTab('negotiations'); });

    $$('[data-rnw-neg-action]', detailEl).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var action = btn.getAttribute('data-rnw-neg-action');
        if (action === 'checkout') { startNegotiationCheckout(n); return; }
        respondToNegotiation(n.id, action);
      });
    });

    // Counter form: total + cert picker → derived yarn $/kg + savings
    var totalEl = $('[data-rnw-neg-counter-total]', detailEl);
    var breakEl = $('[data-rnw-neg-counter-breakdown]', detailEl);
    var certSelects = $$('[data-rnw-neg-cert]', detailEl);
    if (totalEl) {
      function calcCertsTotal() {
        var s = 0;
        certSelects.forEach(function (sel) {
          var pct = parseInt(sel.value, 10) || 0;
          if (pct <= 0) return;
          var allowed = (n.allowedCertificates || []).find(function (a) { return String(a.certificateId) === String(sel.getAttribute('data-rnw-neg-cert')); });
          if (!allowed) return;
          var tier = (allowed.tiers || []).find(function (t) { return Number(t.percent) === pct; });
          if (tier) s += n.kg * tier.pricePerKg;
        });
        return s;
      }
      function updateBreak() {
        if (!breakEl) return;
        var total = parseFloat(totalEl.value) || 0;
        var certsTotal = calcCertsTotal();
        var listYarn = n.initialPricePerKg * n.kg;
        var listGrand = listYarn + certsTotal;
        var lastSupplierRound = (n.rounds || [])[(n.rounds || []).length - 1] || {};
        var lastSupplierTotal = Number(lastSupplierRound.totalAmount || 0);
        var lines = [];
        lines.push('List package reference: $' + listGrand.toFixed(2));
        if (lastSupplierTotal > 0) lines.push('Supplier\'s last offer: <strong>$' + lastSupplierTotal.toFixed(2) + '</strong>');
        if (total > 0) {
          var yarnTotal = total - certsTotal;
          var yarnPerKg = yarnTotal / n.kg;
          if (yarnTotal <= 0) {
            lines.push('<span style="color:#991b1b;">Your total ($' + total.toFixed(2) + ') is below the certificate cost ($' + certsTotal.toFixed(2) + ').</span>');
          } else if (yarnPerKg >= n.initialPricePerKg) {
            lines.push('<span style="color:#92400e;">Derived yarn $' + yarnPerKg.toFixed(2) + '/kg is not below list $' + Number(n.initialPricePerKg).toFixed(2) + '/kg.</span>');
          } else if (lastSupplierTotal > 0 && total >= lastSupplierTotal) {
            lines.push('<span style="color:#92400e;">Your counter ($' + total.toFixed(2) + ') must be lower than the supplier\'s last offer ($' + lastSupplierTotal.toFixed(2) + ').</span>');
          } else {
            var savings = lastSupplierTotal > 0 ? lastSupplierTotal - total : (listGrand - total);
            lines.push('Your counter: <strong>$' + total.toFixed(2) + '</strong>');
            if (savings > 0) {
              var ref = lastSupplierTotal > 0 ? lastSupplierTotal : listGrand;
              var pct = Math.round((savings / ref) * 100);
              lines.push('<span style="color:#065f46; font-weight:600;">$' + savings.toFixed(2) + ' (' + pct + '%) below ' + (lastSupplierTotal > 0 ? 'supplier offer' : 'list') + '</span>');
            }
          }
        }
        breakEl.innerHTML = lines.join(' · ');
      }
      totalEl.addEventListener('input', updateBreak);
      certSelects.forEach(function (sel) { sel.addEventListener('change', updateBreak); });
      updateBreak();
    }
  }

  function respondToNegotiation(id, action) {
    var detailEl = $('[data-rnw-negotiation-detail]');
    var errEl = $('[data-rnw-neg-err]', detailEl);
    if (errEl) errEl.hidden = true;
    var body = { action: action };
    if (action === 'counter') {
      var total = parseFloat(($('[data-rnw-neg-counter-total]', detailEl) || {}).value);
      var msg = (($('[data-rnw-neg-counter-msg]', detailEl) || {}).value) || '';
      if (!total || total <= 0) { if (errEl) { errEl.textContent = 'Please enter a counter total.'; errEl.hidden = false; } return; }
      var current = state.currentNegotiation;
      // Cert picker seçimleri
      var certs = [];
      $$('[data-rnw-neg-cert]', detailEl).forEach(function (sel) {
        var pct = parseInt(sel.value, 10) || 0;
        if (pct > 0) certs.push({ certificateId: sel.getAttribute('data-rnw-neg-cert'), percent: pct });
      });
      // Client-side soft checks: 3 kural (müşteri tarafı)
      if (current) {
        var certsTotal = certs.reduce(function (s, c) {
          var allowed = (current.allowedCertificates || []).find(function (a) { return String(a.certificateId) === String(c.certificateId); });
          if (!allowed) return s;
          var tier = (allowed.tiers || []).find(function (t) { return Number(t.percent) === Number(c.percent); });
          return s + (tier ? current.kg * tier.pricePerKg : 0);
        }, 0);
        // (1) Sertifika maliyetinden büyük olmalı (yarn pozitif)
        if (total <= certsTotal) {
          if (errEl) { errEl.textContent = 'Total ($' + total.toFixed(2) + ') must exceed certificate cost ($' + certsTotal.toFixed(2) + ').'; errEl.hidden = false; }
          return;
        }
        // (2) Yarn $/kg liste fiyatından düşük olmalı
        var derivedYarn = (total - certsTotal) / current.kg;
        if (current.initialPricePerKg && derivedYarn >= current.initialPricePerKg) {
          if (errEl) { errEl.textContent = 'Derived yarn $' + derivedYarn.toFixed(2) + '/kg is not lower than list $' + Number(current.initialPricePerKg).toFixed(2) + '/kg. Lower total or remove certificates.'; errEl.hidden = false; }
          return;
        }
        // (3) Son tedarikçi tekliften düşük olmalı (pazarlık ilerlemeli)
        var lastSupplierRound = (current.rounds || [])[(current.rounds || []).length - 1] || {};
        var lastSupplierTotal = Number(lastSupplierRound.totalAmount || 0);
        if (lastSupplierTotal > 0 && total >= lastSupplierTotal) {
          if (errEl) { errEl.textContent = 'Your counter ($' + total.toFixed(2) + ') must be lower than the supplier’s latest offer ($' + lastSupplierTotal.toFixed(2) + ').'; errEl.hidden = false; }
          return;
        }
      }
      body.totalAmount = total;
      body.message = msg;
      body.certificates = certs;
    }
    if (action === 'reject') {
      if (!confirm('Decline this negotiation?')) return;
    }
    api('/panel/buyer/api/negotiations/' + id + '/respond', { method: 'POST', body: body }).then(function (res) {
      if (!res.ok) { if (errEl) { errEl.textContent = res.data.error || 'Could not respond'; errEl.hidden = false; } return; }
      renderNegotiationDetail(res.data.negotiation);
    });
  }

  function startNegotiationCheckout(n) {
    var c = state.customer || {};
    var addrs = state.addresses || [];
    var def = addrs.find(function (a) { return a.isDefault; }) || addrs[0] || {};
    if (!c.name || !c.email) { alert('Please complete your profile first.'); switchDashboardTab('settings'); return; }
    if (!def.addressLine) { alert('Please add a delivery address first.'); switchDashboardTab('addresses'); return; }
    if (!n.offerId || !n.originId) { alert('Negotiation is missing offer/origin reference. Please contact support.'); return; }

    var payload = {
      offerId: n.offerId,
      originId: n.originId,
      negotiationId: n.id,
      kg: n.kg,
      certificates: [],
      buyer: {
        name: c.name, email: c.email, phone: c.phone || '',
        companyName: c.companyName || '', taxNumber: c.taxNumber || '',
        addressLine: def.addressLine, city: def.city || '', district: def.district || '',
        postalCode: def.postalCode || '', country: def.country || 'Türkiye', notes: ''
      },
      // Negotiation checkout: tek seçenek 'need_assistance' (kullanıcı kararı: hızlı flow)
      shipping: { preference: 'need_assistance' },
      // Kartla odeme su an kapali; pazarlik siparisi havale/EFT ile verilir
      paymentMethod: 'bank_transfer'
    };
    // /api/public/orders cross-origin'dur ama buyer.js'in CORS'ı /api altında. Public-api'nin endpoint'i tunnel'dan çağrılır.
    var orderHeaders = { 'Content-Type': 'application/json' };
    var orderTok = window.rnwToken ? window.rnwToken.get() : '';
    if (orderTok) orderHeaders['Authorization'] = 'Bearer ' + orderTok;
    fetch(API_BASE + '/api/public/orders', {
      method: 'POST',
      credentials: 'include',
      headers: orderHeaders,
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (res.ok && res.body.paymentPageUrl) {
          window.location.href = res.body.paymentPageUrl;
          return;
        }
        if (!res.ok || !res.body.bankTransfer) {
          alert(res.body.error || (isTurkish() ? 'Sipariş oluşturulamadı.' : 'Could not place the order.'));
          return;
        }
        state.orders = [];
        state.requestsLoaded = false;
        if (window.history && window.history.replaceState) window.history.replaceState(null, '', '#orders');
        switchDashboardTab('orders');
      })
      .catch(function (err) { alert('Network error: ' + err.message); });
  }

})();
